<template>
  <div class="follow-up-reports">
    <b-container fluid>
      <h1>Follow Up Reports</h1>
      <b-button
        class="mb-2"
        variant="primary"
        @click="showModal('modal-add-follow-up-report')"
        >Add</b-button
      >
      <b-button
        v-if="this.user.name=='Rick'"
        class="ml-2 mb-2"
        variant="primary"
        @click="testFunction()"
        >Test Function</b-button
      >
      <b-form-checkbox
        v-model.trim="showAllReports"
        value="true"
        unchecked-value="false"
        >Show complete events</b-form-checkbox
      >
      <b-row>
        <b-col>
          <b-form-group label-for="filterCriteria">
            <b-input-group>
              <b-form-input
                type="text"
                id="filterCriteria"
                v-model.trim="filterCriteria"
                class="form-control"
                placeholder="Type to search"
              ></b-form-input>
              <b-input-group-append>
                <b-button @click="cleanFilterInfo()" variant="primary"
                  ><b-icon icon="x-circle" variant="white"></b-icon
                ></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-h="between">
        <b-col cols="3">
          <b-pagination
            v-model.trim="currentPage"
            :page="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
        <b-col cols="8">
          <b-row align-h="end">
            <b-col>
              <div class="flexbox">
                <b-label class="mr-1">From:</b-label>
                <b-form-datepicker
                  v-model.trim="time_range.start"
                  placeholder="start date"
                ></b-form-datepicker>
              </div>
            </b-col>
            <b-col>
              <div class="flexbox">
                <b-label class="mr-1">To:</b-label>
                <b-form-datepicker
                  v-model.trim="time_range.end"
                  placeholder="end date"
                ></b-form-datepicker>
              </div>
            </b-col>
            <b-col>
              <b-button-group>
                <b-button variant="primary" @click="submitTimeRange()"
                  >Submit</b-button
                >
                <b-button variant="secondary" @click="resetTimeRange()"
                  >Reset</b-button
                >
              </b-button-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- <p class="mt-3">Current Page: {{ currentPage }}</p> -->

      <b-table
        class="pointer mt-2"
        id="my-table"
        striped
        responsive
        bordered
        :fields="follow_up_report_fields"
        :filter="filterCriteria"
        :filter-included-fields="filterOn"
        :items="displayed_reports"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="tableIsBusy"
        small
      >
        <!-- <template #cell(actions)="row">
          <b-button class="table-button" size=sm variant="primary" @click="view_follow_up_report(row.item)">View</b-button>
          <b-button class="table-button ml-1" size=sm variant="danger" @click="delete_follow_up_report(row.item.id)">Delete</b-button>
        </template> -->
        <template #thead-top>
          <b-tr>
            <b-th class="v-th" colspan="2"></b-th>
            <b-th class="v-th text-center" colspan="2" variant="light">Contract</b-th>
            <b-th class="v-th text-center" colspan="3" variant="light">Plan</b-th>
            <b-th class="v-th text-center" colspan="2" variant="light">Permit</b-th>
            <b-th class="v-th text-center" colspan="2" variant="light">Stone</b-th>
            <b-th class="v-th text-center" colspan="1"></b-th>
            <b-th class="v-th text-center" colspan="2" variant="light">Foundation</b-th>
            <b-th class="v-th text-center" colspan="4"></b-th>
            <b-th class="v-th text-center" colspan="1" variant="light">Install</b-th>
          </b-tr>
        </template>

        <template #head(invoice_number)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(follower)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(contract_signed_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(contract_due_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(request_plan_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(sent_to_client_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(plan_signed_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(permit_sent_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(permit_approved_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(order_placed_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(order_received_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(photo)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(foundation_ordered_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(foundation_done_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(foundation_container_number)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(inscription_dates)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(accessory)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(installation_booked_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(job_complete_date)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #head(invoice_number_2)="data">
          <div class="text-center">{{data.label}}</div>
        </template>

        <template #custom-foot>
          <b-tr>
            <b-th class="text-center">Invoice #</b-th>
            <b-th class="text-center">Sales</b-th>
            <b-th class="text-center">Signed</b-th>
            <b-th class="text-center">Due</b-th>
            <b-th class="text-center">Request</b-th>
            <b-th class="text-center">Sent</b-th>
            <b-th class="text-center">Signed</b-th>
            <b-th class="text-center">Sent</b-th>
            <b-th class="text-center">Received</b-th>
            <b-th class="text-center">Ordered</b-th>
            <b-th class="text-center">Received</b-th>
            <b-th class="text-center">Photo</b-th>
            <b-th class="text-center">Ordered</b-th>
            <b-th class="text-center">Done</b-th>
            <b-th class="text-center">Container #</b-th>
            <b-th class="text-center">Inscription</b-th>
            <b-th class="text-center">Accessory</b-th>
            <b-th class="text-center">Final Payment</b-th>
            <b-th class="text-center">Booked</b-th>
            <b-th class="text-center">Complete</b-th>
            <b-th class="text-center">Invoice #</b-th>
          </b-tr>
          <b-tr>
            <b-th colspan="2"><span class="sr-only">Invoice number and Sales</span></b-th>
            <b-th colspan="2" variant="light" class="text-center">Contract</b-th>
            <b-th colspan="3" variant="light" class="text-center">Plan</b-th>
            <b-th colspan="2" variant="light" class="text-center">Permit</b-th>
            <b-th colspan="2" variant="light" class="text-center">Stone</b-th>
            <b-th colspan="1"><span class="sr-only">Photo</span></b-th>
            <b-th colspan="2" variant="light" class="text-center">Foundation</b-th>
            <b-th class="v-th text-center" colspan="4"></b-th>
            <b-th class="v-th text-center" colspan="1" variant="light">Install</b-th>
          </b-tr>
        </template>

        <template #cell(invoice_number)="row">
          <div
            class="table-button text-center"
            @click="myRowClickHandler(Object.assign({}, row.item))"
          >
            {{ row.item.invoice_number }}
          </div>
        </template>

        <template #cell(follower)="row">
          <div
            class="table-button text-center"
            @click="follower_clicked(Object.assign({}, row.item))"
          >
            {{row.item.follower}}
          </div>
        </template>

        <template #cell(contract_signed_date)="row">
          <div
            class="table-button text-center"
            @click="contract_signed_date_clicked(Object.assign({}, row.item))"
          >
            {{formatDate(row.item.contract_signed_date)}}
          </div>
        </template>

        <template #cell(contract_due_date)="row">
          <div
            class="table-button text-center"
            @click="contract_due_date_clicked(Object.assign({}, row.item))"
          >
            {{formatDate(row.item.contract_due_date)}}
          </div>
        </template>

        <template #cell(request_plan_date)="row">
          <div
            v-if="
              !row.item.plan_not_required ||
                row.item.plan_not_required == 'false'
            "
            class="table-button text-center"
            @click="request_plan_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.request_plan_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.request_plan_date_comment != null &&
                  row.item.request_plan_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.plan_not_required == 'true'"
            class="table-button text-center" 
            @click="request_plan_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.request_plan_date_comment != null &&
                  row.item.request_plan_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(sent_to_client_date)="row">
          <div
            v-if="
              !row.item.plan_not_required ||
                row.item.plan_not_required == 'false'
            "
            class="table-button text-center"
            @click="sent_to_client_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.sent_to_client_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.sent_to_client_date_comment != null &&
                  row.item.sent_to_client_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.plan_not_required == 'true'"
            class="table-button text-center"
            @click="sent_to_client_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.sent_to_client_date_comment != null &&
                  row.item.sent_to_client_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(plan_signed_date)="row">
          <div
            v-if="
              !row.item.plan_not_required ||
                row.item.plan_not_required == 'false'
            "
            class="table-button text-center"
            @click="plan_signed_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.plan_signed_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.plan_signed_date_comment != null &&
                  row.item.plan_signed_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.plan_not_required == 'true'"
            class="table-button text-center"
            @click="plan_signed_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.plan_signed_date_comment != null &&
                  row.item.plan_signed_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(permit_sent_date)="row">
          <div
            v-if="
              !row.item.permit_not_required ||
                row.item.permit_not_required == 'false'
            "
            class="table-button text-center"
            @click="permit_sent_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.permit_sent_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.permit_sent_date_comment != null &&
                  row.item.permit_sent_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.permit_not_required == 'true'"
            class="table-button text-center"
            @click="permit_sent_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.permit_sent_date_comment != null &&
                  row.item.permit_sent_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(permit_approved_date)="row">
          <div
            v-if="
              !row.item.permit_not_required ||
                row.item.permit_not_required == 'false'
            "
            class="table-button text-center"
            @click="permit_approved_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.permit_approved_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.permit_approved_date_comment != null &&
                row.item.permit_approved_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.permit_not_required == 'true'"
            class="table-button text-center"
            @click="permit_approved_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.permit_approved_date_comment != null &&
                  row.item.permit_approved_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(order_placed_date)="row">
          <div
            v-if="
              !row.item.stone_order_not_required ||
                row.item.stone_order_not_required == 'false'
            "
            class="table-button text-center"
            @click="order_placed_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.order_placed_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.order_placed_date_comment != null &&
                  row.item.order_placed_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.stone_order_not_required == 'true'"
            class="table-button text-center"
            @click="order_placed_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.order_placed_date_comment != null &&
                  row.item.order_placed_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(order_received_date)="row">
          <div
            v-if="
              !row.item.stone_order_not_required ||
                row.item.stone_order_not_required == 'false'
            "
            class="table-button text-center"
            @click="order_received_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.order_received_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.order_received_date_comment != null &&
                  row.item.order_received_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.stone_order_not_required == 'true'"
            class="table-button text-center"
            @click="order_received_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.order_received_date_comment != null &&
                  row.item.order_received_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <!-- <template #cell(photo_sent_date)="row">
          <div
            v-if="
              !row.item.photo_sent_date_not_required ||
                row.item.photo_sent_date_not_required == 'false'
            "
            class="table-button"
            @click="photo_sent_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.photo_sent_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.photo_sent_date_comment != null &&
                  row.item.photo_sent_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.photo_sent_date_not_required == 'true'"
            class="table-button"
            @click="photo_sent_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.photo_sent_date_comment != null &&
                  row.item.photo_sent_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template> -->

        <template #cell(photo)="row">
          <div
            v-if="row.item.photo != null" 
            class="table-button"
            @click="photo_clicked(row.item)">
            <b-progress :max="row.item.photo.required_item_number" height="1.6rem">
              <b-progress-bar 
                v-if="!row.item.photo.not_required"
                :variant="row.item.photo.progress < row.item.photo.required_item_number ? 'warning' : 'success'"
                :value="row.item.photo.progress">
                <span>
                  <strong>{{ row.item.photo.progress }} / {{ row.item.photo.required_item_number }}</strong>
                </span>
              </b-progress-bar>
              <b-progress-bar 
                v-if="row.item.photo.not_required"
                variant='success'
                :value="row.item.photo.required_item_number">
                <span><strong>N/R</strong></span>
              </b-progress-bar>
            </b-progress>
          </div>
        </template>

        <!-- <template #cell(photo_approved_date)="row">
          <div
            v-if="
              !row.item.photo_approved_date_not_required ||
                row.item.photo_approved_date_not_required == 'false'
            "
            class="table-button"
            @click="photo_approved_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.photo_approved_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.photo_approved_date_comment != null &&
                  row.item.photo_approved_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.photo_approved_date_not_required == 'true'"
            class="table-button"
            @click="photo_approved_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.photo_approved_date_comment != null &&
                  row.item.photo_approved_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template> -->

        <template #cell(foundation_ordered_date)="row">
          <div
            v-if="
              !row.item.foundation_not_required ||
                row.item.foundation_not_required == 'false'
            "
            class="table-button text-center"
            @click="
              foundation_ordered_date_clicked(Object.assign({}, row.item))
            "
          >
            {{ formatDate(row.item.foundation_ordered_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.foundation_ordered_date_comment != null &&
                  row.item.foundation_ordered_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.foundation_not_required == 'true'"
            class="table-button text-center"
            @click="
              foundation_ordered_date_clicked(Object.assign({}, row.item))
            "
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.foundation_ordered_date_comment != null &&
                  row.item.foundation_ordered_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(foundation_done_date)="row">
          <div
            v-if="
              !row.item.foundation_not_required ||
                row.item.foundation_not_required == 'false'
            "
            class="table-button text-center"
            @click="foundation_done_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.foundation_done_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.foundation_done_date_comment != null &&
                  row.item.foundation_done_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.foundation_not_required == 'true'"
            class="table-button text-center"
            @click="foundation_done_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.foundation_done_date_comment != null &&
                  row.item.foundation_done_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(foundation_container_number)="row">
          <div style="width: 90px"
            class="table-button text-center"
            @click="foundation_container_number_clicked(Object.assign({}, row.item))"
          >
            {{ row.item.foundation_container_number }}
          </div>
        </template>

        <template #cell(inscription_dates)="row">
          <div
            v-if="row.item.inscription != null" 
            class="table-button"
            @click="inscription_dates_clicked(row.item)">
            <b-progress :max="row.item.inscription.inscription_required_item_number" height="1.6rem">
              <b-progress-bar 
                v-if="!row.item.inscription.inscription_not_required"
                :variant="row.item.inscription.inscription_progress < row.item.inscription.inscription_required_item_number? 'warning' : 'success'"
                :value="row.item.inscription.inscription_progress">
                <span><strong>{{ row.item.inscription.inscription_progress }} / {{ row.item.inscription.inscription_required_item_number }}</strong></span>
              </b-progress-bar>
              <b-progress-bar 
                v-if="row.item.inscription.inscription_not_required"
                variant='success'
                :value="row.item.inscription.inscription_required_item_number * 2">
                <span><strong>N/R</strong></span>
              </b-progress-bar>
            </b-progress>
          </div>
        </template>

        <template #cell(accessory)="row">
          <div
            v-if="row.item.accessory != null" 
            class="table-button"
            @click="accessory_dates_clicked(row.item)">
            <b-progress :max="row.item.accessory.required_item_number == 0? 1 : row.item.accessory.required_item_number * 2" height="1.6rem">
              <b-progress-bar 
                v-if="!row.item.accessory.not_required"
                :variant="row.item.accessory.progress < row.item.accessory.required_item_number*2 ? 'warning' : 'success'"
                :value="row.item.accessory.progress">
                <span><strong>{{ row.item.accessory.progress }} / {{ row.item.accessory.required_item_number*2 }}</strong></span>
              </b-progress-bar>
              <b-progress-bar 
                v-if="row.item.accessory.not_required"
                variant='success'
                :value="row.item.accessory.required_item_number == 0? 1 : row.item.accessory.required_item_number * 2">
                <span><strong>N/R</strong></span>
              </b-progress-bar>
            </b-progress>
          </div>
        </template>

        <template #cell(inscription_got_date)="row">
          <div
            v-if="
              !row.item.inscription_got_date_not_required ||
                row.item.inscription_got_date_not_required == 'false'
            "
            class="table-button"
            @click="inscription_got_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.inscription_got_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.inscription_got_date_comment != null &&
                  row.item.inscription_got_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.inscription_got_date_not_required == 'true'"
            class="table-button"
            @click="inscription_got_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.inscription_got_date_comment != null &&
                  row.item.inscription_got_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(inscription_sent_date)="row">
          <div
            v-if="
              !row.item.inscription_sent_date_not_required ||
                row.item.inscription_sent_date_not_required == 'false'
            "
            class="table-button"
            @click="inscription_sent_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.inscription_sent_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.inscription_sent_date_comment != null &&
                  row.item.inscription_sent_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.inscription_sent_date_not_required == 'true'"
            class="table-button"
            @click="inscription_sent_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.inscription_sent_date_comment != null &&
                  row.item.inscription_sent_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(inscription_signed_date)="row">
          <div
            v-if="
              !row.item.inscription_signed_date_not_required ||
                row.item.inscription_signed_date_not_required == 'false'
            "
            class="table-button"
            @click="
              inscription_signed_date_clicked(Object.assign({}, row.item))
            "
          >
            {{ formatDate(row.item.inscription_signed_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.inscription_signed_date_comment != null &&
                  row.item.inscription_signed_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.inscription_signed_date_not_required == 'true'"
            class="table-button"
            @click="
              inscription_signed_date_clicked(Object.assign({}, row.item))
            "
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.inscription_signed_date_comment != null &&
                  row.item.inscription_signed_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(inscription_booked_date)="row">
          <div
            v-if="
              !row.item.inscription_booked_date_not_required ||
                row.item.inscription_booked_date_not_required == 'false'
            "
            class="table-button"
            @click="
              inscription_booked_date_clicked(Object.assign({}, row.item))
            "
          >
            {{ formatDate(row.item.inscription_booked_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.inscription_booked_date_comment != null &&
                  row.item.inscription_booked_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.inscription_booked_date_not_required == 'true'"
            class="table-button"
            @click="
              inscription_booked_date_clicked(Object.assign({}, row.item))
            "
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.inscription_booked_date_comment != null &&
                  row.item.inscription_booked_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(accessory_ordered_date)="row">
          <div
            v-if="
              !row.item.accessory_ordered_date_not_required ||
                row.item.accessory_ordered_date_not_required == 'false'
            "
            class="table-button"
            @click="accessory_ordered_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.accessory_ordered_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.accessory_ordered_date_comment != null &&
                  row.item.accessory_ordered_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.accessory_ordered_date_not_required == 'true'"
            class="table-button"
            @click="accessory_ordered_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.accessory_ordered_date_comment != null &&
                  row.item.accessory_ordered_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(accessory_received_date)="row">
          <div
            v-if="
              !row.item.accessory_received_date_not_required ||
                row.item.accessory_received_date_not_required == 'false'
            "
            class="table-button"
            @click="
              accessory_received_date_clicked(Object.assign({}, row.item))
            "
          >
            {{ formatDate(row.item.accessory_received_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.accessory_received_date_comment != null &&
                  row.item.accessory_received_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.accessory_received_date_not_required == 'true'"
            class="table-button"
            @click="
              accessory_received_date_clicked(Object.assign({}, row.item))
            "
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.accessory_received_date_comment != null &&
                  row.item.accessory_received_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(final_payment_date)="row">
          <div
            class="table-button text-center"
            style="min-width: 110px;"
            @click="final_payment_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.final_payment_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.final_payment_date_comment != null &&
                  row.item.final_payment_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(installation_booked_date)="row">
          <div
            v-if="
              !row.item.installation_booked_date_not_required ||
                row.item.installation_booked_date_not_required == 'false'
            "
            class="table-button text-center"
            @click="
              installation_booked_date_clicked(Object.assign({}, row.item))
            "
          >
            {{ formatDate(row.item.installation_booked_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.installation_booked_date_comment != null &&
                  row.item.installation_booked_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.installation_booked_date_not_required == 'true'"
            class="table-button text-center"
            @click="
              installation_booked_date_clicked(Object.assign({}, row.item))
            "
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.installation_booked_date_comment != null &&
                  row.item.installation_booked_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(job_complete_date)="row">
          <div
            class="table-button text-center"
            @click="job_complete_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.job_complete_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.job_complete_date_comment != null &&
                  row.item.job_complete_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(invoice_number_2)="row">
          <div
            class="table-button text-center"
            @click="myRowClickHandler(Object.assign({}, row.item))"
          >
            {{ row.item.invoice_number }}
          </div>
        </template>
      </b-table>
    </b-container>

    <b-modal
      id="modal-delete-follow-up-report"
      title="Delete confirmation"
      hide-footer
    >
      <p>This operation will delete a follow up report.</p>
      <div class="modal-footer mt-1">
        <b-button
          variant="secondary"
          @click="hideModal('modal-delete-follow-up-report')"
        >
          Cancel
        </b-button>
        <b-button
          :disabled="isDeleting"
          variant="danger"
          @click="delete_follow_up_report_task()"
        >
          <span v-if="!isDeleting">Delete</span>
          <span v-if="isDeleting">
            <b-spinner small type="grow"></b-spinner>
            Deleting...
          </span>
        </b-button>
      </div>
    </b-modal>

    <!-- ADD FOLLOW UP REPORT -->
    <b-modal
      id="modal-add-follow-up-report"
      hide-footer
      title="Add follow up report"
    >
      <b-form @submit.prevent="add_follow_up_report">
        <label for="follow_up_report_invoice_number">Invoice No.:</label>
        <b-input
          type="text"
          id="invoice_number"
          v-model.trim="new_follow_up_report.invoice_number"
          required
        ></b-input>

        <label for="contract_signed_date">Contract Signed Date:</label>
        <b-form-datepicker
          locale="en"
          type="date"
          today-button
          reset-button
          close-button
          id="contract_signed_date"
          v-model.trim="new_follow_up_report.contract_signed_date"
          class="form-control"
          aria-required="true"
        ></b-form-datepicker>

        <!-- <label for="contract_due_date">Contract Due Date:</label>
        <b-form-datepicker type="date" today-button
      reset-button
      close-button
          id="contract_due_date"
          v-model.trim="new_follow_up_report.contract_due_date"
          class="form-control"></b-form-datepicker> -->

        <label for="request_plan_date">Plan Request Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_plan_not_required"
          v-model.trim="new_follow_up_report.plan_not_required"
          name="new_plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          :disabled="
            new_follow_up_report.plan_not_required == 'true'
          "
          id="request_plan_date"
          v-model.trim="new_follow_up_report.request_plan_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="sent_to_client_date">Plan Sent:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_plan_not_required"
          v-model.trim="new_follow_up_report.plan_not_required"
          name="new_plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="sent_to_client_date"
          v-model.trim="new_follow_up_report.sent_to_client_date"
          class="form-control"
          :disabled="
            new_follow_up_report.plan_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="plan_signed_date">Plan Signed Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_plan_not_required"
          v-model.trim="new_follow_up_report.plan_not_required"
          name="new_plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="plan_signed_date"
          v-model.trim="new_follow_up_report.plan_signed_date"
          class="form-control"
          :disabled="
            new_follow_up_report.plan_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="permit_sent_date">Permit Sent Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_permit_not_required"
          v-model.trim="new_follow_up_report.permit_not_required"
          name="new_permit_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="permit_sent_date"
          v-model.trim="new_follow_up_report.permit_sent_date"
          class="form-control"
          :disabled="
            new_follow_up_report.permit_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="permit_approved_date">Permit Received Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_permit_not_required"
          v-model.trim="new_follow_up_report.permit_not_required"
          name="new_permit_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="permit_approved_date"
          v-model.trim="new_follow_up_report.permit_approved_date"
          class="form-control"
          :disabled="
            new_follow_up_report.permit_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="order_placed_date">Order Placed Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_stone_order_not_required"
          v-model.trim="new_follow_up_report.stone_order_not_required"
          name="new_stone_order_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="order_placed_date"
          v-model.trim="new_follow_up_report.order_placed_date"
          class="form-control"
          :disabled="
            new_follow_up_report.stone_order_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="order_received_date">Order Received Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_stone_order_not_required"
          v-model.trim="new_follow_up_report.stone_order_not_required"
          name="new_stone_order_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="order_received_date"
          v-model.trim="new_follow_up_report.order_received_date"
          class="form-control"
          :disabled="
            new_follow_up_report.stone_order_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="photo_sent_date">Photo Sent Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_photo_sent_date_not_required"
          v-model.trim="new_follow_up_report.photo_sent_date_not_required"
          name="new_photo_sent_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="photo_sent_date"
          v-model.trim="new_follow_up_report.photo_sent_date"
          class="form-control"
          :disabled="
            new_follow_up_report.photo_sent_date_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="photo_approved_date">Photo Received Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_photo_approved_date_not_required"
          v-model.trim="new_follow_up_report.photo_approved_date_not_required"
          name="new_photo_approved_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="photo_approved_date"
          v-model.trim="new_follow_up_report.photo_approved_date"
          class="form-control"
          :disabled="
            new_follow_up_report.photo_approved_date_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="foundation_ordered_date">Foundation Ordered Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_foundation_not_required"
          v-model.trim="new_follow_up_report.foundation_not_required"
          name="new_foundation_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="foundation_ordered_date"
          v-model.trim="new_follow_up_report.foundation_ordered_date"
          class="form-control"
          :disabled="
            new_follow_up_report.foundation_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="inscription_got_date"
          >Inscription Writing Recorded Date::</label
        >
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_inscription_got_date_not_required"
          v-model.trim="new_follow_up_report.inscription_got_date_not_required"
          name="new_inscription_got_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_got_date"
          v-model.trim="new_follow_up_report.inscription_got_date"
          class="form-control"
          :disabled="
            new_follow_up_report.inscription_got_date_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="inscription_sent_date">Inscription Sent Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_inscription_sent_date_not_required"
          v-model.trim="new_follow_up_report.inscription_sent_date_not_required"
          name="new_inscription_sent_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_sent_date"
          v-model.trim="new_follow_up_report.inscription_sent_date"
          class="form-control"
          :disabled="
            new_follow_up_report.inscription_sent_date_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="inscription_signed_date">Inscription Signed Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_inscription_signed_date_not_required"
          v-model.trim="new_follow_up_report.inscription_signed_date_not_required"
          name="new_inscription_signed_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_signed_date"
          v-model.trim="new_follow_up_report.inscription_signed_date"
          class="form-control"
          :disabled="
            new_follow_up_report.inscription_signed_date_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="inscription_booked_date">Inscription Booked Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_inscription_booked_date_not_required"
          v-model.trim="new_follow_up_report.inscription_booked_date_not_required"
          name="new_inscription_booked_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_booked_date"
          v-model.trim="new_follow_up_report.inscription_booked_date"
          class="form-control"
          :disabled="
            new_follow_up_report.inscription_booked_date_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="accessory_ordered_date">Accessory Ordered Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_accessory_ordered_date_not_required"
          v-model.trim="new_follow_up_report.accessory_ordered_date_not_required"
          name="new_accessory_ordered_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="accessory_ordered_date"
          v-model.trim="new_follow_up_report.accessory_ordered_date"
          class="form-control"
          :disabled="
            new_follow_up_report.accessory_ordered_date_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="accessory_received_date">Accessory Received Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_accessory_received_date_not_required"
          v-model.trim="new_follow_up_report.accessory_received_date_not_required"
          name="new_accessory_received_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="accessory_received_date"
          v-model.trim="new_follow_up_report.accessory_received_date"
          class="form-control"
          :disabled="
            new_follow_up_report.accessory_received_date_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="installation_booked_date">Installation Booked Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="new_installation_booked_date_not_required"
          v-model.trim="new_follow_up_report.installation_booked_date_not_required"
          name="new_installation_booked_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="installation_booked_date"
          v-model.trim="new_follow_up_report.installation_booked_date"
          class="form-control"
          :disabled="
            new_follow_up_report.installation_booked_date_not_required == 'true'
          "
        ></b-form-datepicker>

        <label for="cemetery_name">Cemetery:</label>
        <b-form-select
          id="cemetery"
          v-model.trim="new_follow_up_report.cemetery_name"
          :options="cemetery_names"
          required
        ></b-form-select>

        <label for="follower">Who is following:</label>
        <!-- <p v-if="this.user.role == 'sales'">{{this.user.name}}</p> -->
        <b-form-select
          id="follower"
          v-model.trim="new_follow_up_report.follower"
          :options="sales_names"
          required
        ></b-form-select>

        <label for="description">Description:</label>
        <b-textarea
          type="text"
          id="description"
          v-model.trim="new_follow_up_report.description"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-add-follow-up-report')">
            Cancel
          </b-button>
          <b-button :disabled="isSubmitting" type="submit" variant="primary">
            <span v-if="!isSubmitting">Submit</span>
            <span v-if="isSubmitting">
              <b-spinner small type="grow"></b-spinner>
              Submitting...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- EDIT COLUMNS -->
    <b-modal id="modal-edit-invoice-number" hide-footer title="Invoice number">
      <b-form>
        <label for="follow_up_report_invoice_number">Invoice No.:</label>
        <b-input
          type="text"
          id="invoice_number"
          v-model.trim="viewed_follow_up_report.invoice_number"
          required
        ></b-input>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-invoice-number')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-follower" hide-footer title="Sales">
      <b-form @submit.prevent="edit_follower">
        <label for="follower">Who is following:</label>
        <b-form-select
          id="follower"
          v-model.trim="viewed_follow_up_report.follower"
          :options="sales_names"
          required
        ></b-form-select>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-follower')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-contract-signed"
      hide-footer
      title="Contract Signed"
    >
      <b-form @submit.prevent="edit_contract_signed_date">
        <label for="contract_signed_date">Contract Signed Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="contract_signed_date"
          v-model.trim="viewed_follow_up_report.contract_signed_date"
          class="form-control"
        ></b-form-datepicker>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-contract-signed')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-contract-due" hide-footer title="Contract Due">
      <b-form @submit.prevent="edit_contract_due_date">
        <label for="contract_due_date">Contract Due Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="contract_due_date"
          v-model.trim="viewed_follow_up_report.contract_due_date"
          class="form-control"
        ></b-form-datepicker>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-contract-due')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-request-plan" hide-footer title="Plan Request">
      <b-form @submit.prevent="edit_request_plan_date">
        <label for="request_plan_date">Plan Request Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.plan_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          :disabled="
            viewed_follow_up_report.plan_not_required == 'true'
          "
          id="request_plan_date"
          v-model.trim="viewed_follow_up_report.request_plan_date"
          class="form-control"
        ></b-form-datepicker>
        <label for="request_plan_date_description">Comment:</label>
        <b-textarea
          type="text"
          id="request_plan_date_description"
          v-model.trim="viewed_follow_up_report.request_plan_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-request-plan')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-sent-to-client" hide-footer title="Sent To Client">
      <b-form>
        <label for="sent_to_client_date">Plan Sent:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.plan_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="sent_to_client_date"
          v-model.trim="viewed_follow_up_report.sent_to_client_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.plan_not_required == 'true'
          "
        ></b-form-datepicker>
        <label for="sent_to_client_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="sent_to_client_date_comment"
          v-model.trim="viewed_follow_up_report.sent_to_client_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-sent-to-client')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-plan-signed" hide-footer title="Plan Signed">
      <b-form @submit.prevent="edit_plan_signed_date">
        <label for="plan_signed_date">Plan Signed Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.plan_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="plan_signed_date"
          v-model.trim="viewed_follow_up_report.plan_signed_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.plan_not_required == 'true'
          "
        ></b-form-datepicker>
        <label for="plan_signed_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="plan_signed_date_comment"
          v-model.trim="viewed_follow_up_report.plan_signed_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-plan-signed')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-permit-sent" hide-footer title="Permit Sent">
      <b-form @submit.prevent="edit_permit_sent_date">
        <label for="permit_sent_date">Permit Sent Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.permit_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="permit_sent_date"
          v-model.trim="viewed_follow_up_report.permit_sent_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.permit_not_required == 'true'
          "
        ></b-form-datepicker>
        <label for="permit_sent_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="permit_sent_date_comment"
          v-model.trim="viewed_follow_up_report.permit_sent_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-permit-sent')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-permit-received"
      hide-footer
      title="Permit Received"
    >
      <b-form @submit.prevent="edit_permit_approved_date">
        <label for="permit_approved_date">Permit Received Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.permit_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="permit_approved_date"
          v-model.trim="viewed_follow_up_report.permit_approved_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.permit_not_required == 'true'
          "
        ></b-form-datepicker>
        <label for="permit_approved_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="permit_approved_date_comment"
          v-model.trim="viewed_follow_up_report.permit_approved_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-permit-received')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-order-placed-date"
      hide-footer
      title="Stone Ordered"
    >
      <b-form @submit.prevent="edit_order_placed_date">
        <label for="order_placed_date">Stone Ordered Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.stone_order_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="order_placed_date"
          v-model.trim="viewed_follow_up_report.order_placed_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.stone_order_not_required == 'true'
          "
        ></b-form-datepicker>
        <label for="order_placed_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="order_placed_date_comment"
          v-model.trim="viewed_follow_up_report.order_placed_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-order-placed-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-order-received-date"
      hide-footer
      title="Stone Received"
    >
      <b-form @submit.prevent="edit_order_received_date">
        <label for="order_received_date">Stone Received Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.stone_order_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="order_received_date"
          v-model.trim="viewed_follow_up_report.order_received_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.stone_order_not_required == 'true'
          "
        ></b-form-datepicker>
        <label for="order_received_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="order_received_date_comment"
          v-model.trim="viewed_follow_up_report.order_received_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-order-received-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-photo-sent-date" hide-footer title="Photo Sent">
      <b-form @submit.prevent="edit_photo_sent_date">
        <label for="photo_sent_date">Photo Sent Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.photo_sent_date_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="photo_sent_date"
          v-model.trim="viewed_follow_up_report.photo_sent_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.photo_sent_date_not_required == 'true'
          "
        ></b-form-datepicker>
        <label for="photo_sent_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="photo_sent_date_comment"
          v-model.trim="viewed_follow_up_report.photo_sent_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-photo-sent-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-photo-approved-date"
      hide-footer
      title="Photo Received"
    >
      <b-form @submit.prevent="edit_photo_approved_date">
        <label for="photo_approved_date">Photo Received Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.photo_approved_date_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="photo_approved_date"
          v-model.trim="viewed_follow_up_report.photo_approved_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.photo_approved_date_not_required == 'true'
          "
        ></b-form-datepicker>
        <label for="photo_approved_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="photo_approved_date_comment"
          v-model.trim="viewed_follow_up_report.photo_approved_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-photo-approved-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-foundation-ordered-date"
      hide-footer
      title="Foundation Ordered"
    >
      <b-form @submit.prevent="edit_foundation_ordered_date">
        <label for="foundation_ordered_date">Foundation Ordered Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.foundation_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="foundation_ordered_date"
          v-model.trim="viewed_follow_up_report.foundation_ordered_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.foundation_not_required ==
              'true'
          "
        ></b-form-datepicker>
        <label for="foundation_ordered_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="foundation_ordered_date_comment"
          v-model.trim="viewed_follow_up_report.foundation_ordered_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-foundation-ordered-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-foundation-done-date"
      hide-footer
      title="Foundation Ordered"
    >
      <b-form>
        <label for="foundation_ordered_date">Foundation Done Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="foundation_not_required"
          v-model.trim="viewed_follow_up_report.foundation_not_required"
          name="foundation_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="foundation_done_date"
          v-model.trim="viewed_follow_up_report.foundation_done_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.foundation_not_required == 'true'
          "
        ></b-form-datepicker>
        <label for="foundation_done_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="foundation_done_date_comment"
          v-model.trim="viewed_follow_up_report.foundation_done_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-foundation-done-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-foundation-container-number"
      hide-footer
      title="Foundation Container Number"
    >
      <b-form>
        <label for="foundation_container_number">Foundation Container Number:</label>
        <b-form-input
          type="text"
          id="foundation_container_number"
          v-model.trim="viewed_follow_up_report.foundation_container_number"
          class="form-control"
        ></b-form-input>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-foundation-done-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-inscription-got-date"
      hide-footer
      title="Writing Recorded"
    >
      <b-form @submit.prevent="edit_inscription_got_date">
        <label for="inscription_got_date">Writing Recorded Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.inscription_got_date_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_got_date"
          v-model.trim="viewed_follow_up_report.inscription_got_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.inscription_got_date_not_required == 'true'
          "
        ></b-form-datepicker>
        <label for="inscription_got_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="inscription_got_date_comment"
          v-model.trim="viewed_follow_up_report.inscription_got_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-inscription-got-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-inscription-sent-date"
      hide-footer
      title="Inscription Sent"
    >
      <b-form @submit.prevent="edit_inscription_sent_date">
        <label for="inscription_sent_date">Inscription Sent Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.inscription_sent_date_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_sent_date"
          v-model.trim="viewed_follow_up_report.inscription_sent_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.inscription_sent_date_not_required == 'true'
          "
        ></b-form-datepicker>
        <label for="inscription_sent_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="inscription_sent_date_comment"
          v-model.trim="viewed_follow_up_report.inscription_sent_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-inscription-sent-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-inscription-signed-date"
      hide-footer
      title="Inscription Signed"
    >
      <b-form @submit.prevent="edit_inscription_signed_date">
        <label for="inscription_signed_date">Inscription Signed Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.inscription_signed_date_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_signed_date"
          v-model.trim="viewed_follow_up_report.inscription_signed_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.inscription_signed_date_not_required ==
              'true'
          "
        ></b-form-datepicker>
        <label for="inscription_signed_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="inscription_signed_date_comment"
          v-model.trim="viewed_follow_up_report.inscription_signed_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-inscription-signed-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-inscription-booked-date"
      hide-footer
      title="Inscription Booked"
    >
      <b-form @submit.prevent="edit_inscription_booked_date">
        <label for="inscription_booked_date">Inscription Booked Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.inscription_booked_date_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_booked_date"
          v-model.trim="viewed_follow_up_report.inscription_booked_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.inscription_booked_date_not_required ==
              'true'
          "
        ></b-form-datepicker>
        <label for="inscription_booked_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="inscription_booked_date_comment"
          v-model.trim="viewed_follow_up_report.inscription_booked_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-inscription-booked-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-accessory-ordered-date"
      hide-footer
      title="Accessory Ordered"
    >
      <b-form @submit.prevent="edit_accessory_ordered_date">
        <label for="accessory_ordered_date">Accessory Ordered Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.accessory_ordered_date_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="accessory_ordered_date"
          v-model.trim="viewed_follow_up_report.accessory_ordered_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.accessory_ordered_date_not_required ==
              'true'
          "
        ></b-form-datepicker>
        <label for="accessory_ordered_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="accessory_ordered_date_comment"
          v-model.trim="viewed_follow_up_report.accessory_ordered_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-accessory-ordered-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-accessory-received-date"
      hide-footer
      title="Accessory Received"
    >
      <b-form @submit.prevent="edit_accessory_received_date">
        <label for="accessory_received_date">Accessory Received Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="viewed_follow_up_report.accessory_received_date_not_required"
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="accessory_received_date"
          v-model.trim="viewed_follow_up_report.accessory_received_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.accessory_received_date_not_required ==
              'true'
          "
        ></b-form-datepicker>
        <label for="accessory_received_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="accessory_received_date_comment"
          v-model.trim="viewed_follow_up_report.accessory_received_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-accessory-received-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-final-payment-date"
      hide-footer
      title="Final Payment Date"
    >
      <b-form>
        <label for="final_payment_date">Final Payment Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="final_payment_date"
          v-model.trim="viewed_follow_up_report.final_payment_date"
          class="form-control"
        ></b-form-datepicker>
        <label for="final_payment_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="final_payment_date_comment"
          v-model.trim="viewed_follow_up_report.final_payment_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-final-payment-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-installation-booked-date"
      hide-footer
      title="Installation Booked"
    >
      <b-form @submit.prevent="edit_installation_booked_date">
        <label for="installation_booked_date">Installation Booked Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model.trim="
            viewed_follow_up_report.installation_booked_date_not_required
          "
          name="plan_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="installation_booked_date"
          v-model.trim="viewed_follow_up_report.installation_booked_date"
          class="form-control"
          :disabled="
            viewed_follow_up_report.installation_booked_date_not_required ==
              'true'
          "
        ></b-form-datepicker>
        <label for="installation_booked_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="installation_booked_date_comment"
          v-model.trim="viewed_follow_up_report.installation_booked_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-installation-booked-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-job-complete-date"
      hide-footer
      title="Job Complete Date"
    >
      <b-form>
        <label for="job_complete_date">Job Complete Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="job_complete_date"
          v-model.trim="viewed_follow_up_report.job_complete_date"
          class="form-control"
        ></b-form-datepicker>
        <label for="job_complete_date_comment">Comment:</label>
        <b-textarea
          type="text"
          id="job_complete_date_comment"
          v-model.trim="viewed_follow_up_report.job_complete_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-job-complete-date')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- VIEW DAILY REPORT -->
    <b-modal
      size="lg"
      id="modal-view-follow-up-report"
      hide-footer
      title="View report"
    >
      <b-form>
        <label for="follow_up_report_invoice_number">Invoice No.:</label>
        <b-input
          type="text"
          id="invoice_number"
          v-model.trim="viewed_follow_up_report.invoice_number"
          required
        ></b-input>

        <label for="contract_signed_date">Contract Signed Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="contract_signed_date"
          v-model.trim="viewed_follow_up_report.contract_signed_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="contract_due_date">Contract Due Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="contract_due_date"
          v-model.trim="viewed_follow_up_report.contract_due_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="request_plan_date">Plan Request Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="request_plan_date"
          v-model.trim="viewed_follow_up_report.request_plan_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="sent_to_client_date">Plan Sent:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="sent_to_client_date"
          v-model.trim="viewed_follow_up_report.sent_to_client_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="plan_signed_date">Plan Signed Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="plan_signed_date"
          v-model.trim="viewed_follow_up_report.plan_signed_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="permit_sent_date">Permit Sent Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="permit_sent_date"
          v-model.trim="viewed_follow_up_report.permit_sent_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="permit_approved_date">Permit Received Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="permit_approved_date"
          v-model.trim="viewed_follow_up_report.permit_approved_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="order_placed_date">Order Placed Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="order_placed_date"
          v-model.trim="viewed_follow_up_report.order_placed_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="order_received_date">Order Received Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="order_received_date"
          v-model.trim="viewed_follow_up_report.order_received_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="photo_sent_date">Photo Sent Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="photo_sent_date"
          v-model.trim="viewed_follow_up_report.photo_sent_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="photo_approved_date">Photo Received Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="photo_approved_date"
          v-model.trim="viewed_follow_up_report.photo_approved_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="foundation_ordered_date">Foundation Ordered Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="foundation_ordered_date"
          v-model.trim="viewed_follow_up_report.foundation_ordered_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="inscription_got_date">Writing Recorded Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_got_date"
          v-model.trim="viewed_follow_up_report.inscription_got_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="inscription_sent_date">Inscription Sent Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_sent_date"
          v-model.trim="viewed_follow_up_report.inscription_sent_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="inscription_signed_date">Inscription Signed Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_signed_date"
          v-model.trim="viewed_follow_up_report.inscription_signed_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="inscription_booked_date">Inscription Booked Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="inscription_booked_date"
          v-model.trim="viewed_follow_up_report.inscription_booked_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="accessory_ordered_date">Accessory Ordered Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="accessory_ordered_date"
          v-model.trim="viewed_follow_up_report.accessory_ordered_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="accessory_received_date">Accessory Received Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="accessory_received_date"
          v-model.trim="viewed_follow_up_report.accessory_received_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="installation_booked_date">Installation Booked Date:</label>
        <b-form-datepicker
          type="date"
          today-button
          reset-button
          close-button
          id="installation_booked_date"
          v-model.trim="viewed_follow_up_report.installation_booked_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="cemetery_name">Cemetery:</label>
        <b-form-select
          id="cemetery"
          v-model.trim="viewed_follow_up_report.cemetery_name"
          :options="cemetery_names"
          required
        ></b-form-select>

        <label for="follower">Who is following:</label>
        <!-- <p v-if="this.user.role == 'sales'">{{this.user.name}}</p> -->
        <b-form-select
          id="follower"
          v-model.trim="viewed_follow_up_report.follower"
          :options="sales_names"
          required
        ></b-form-select>

        <label for="created_by">Created by:</label>
        <p>{{ viewed_follow_up_report.created_by.name }}</p>

        <label for="description">Description:</label>
        <b-textarea
          type="text"
          id="description"
          v-model.trim="viewed_follow_up_report.description"
        ></b-textarea>

        <div class="modal-footer">
          <b-button
            variant="danger"
            @click="delete_follow_up_report(viewed_follow_up_report.id)"
            >Delete</b-button
          >
          <b-button @click="showModal('modal-edit-histories')"
            >Edit Histories</b-button
          >
          <b-button @click="hideModal('modal-view-follow-up-report')">
            Cancel
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_follow_up_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Edit Histories -->
    <b-modal id="modal-edit-histories" hide-footer title="Edit Histories">
      <div
        v-for="(history, index) in this.viewed_follow_up_report.edit_histories"
        :key="'history' + index"
      >
        <b-row align-v="center" v-b-toggle="'accordion-history' + index">
          <b-col cols="5">
            <strong>{{ history.edit_on }}.{{ history.edit_by }}</strong>
          </b-col>
          <b-col cols="6">
            <hr />
          </b-col>
          <b-col>
            <b-row>
              <b-icon
                icon="chevron-down"
                scale="1"
                variant="secondary"
              ></b-icon>
            </b-row>
          </b-col>
        </b-row>
        <b-collapse
          v-bind:id="'accordion-history' + index"
          role="tabpanel"
          class="mx-3"
        >
          <label
            for="follow_up_report_invoice_number"
            v-if="history.invoice_number.length > 0"
            >Invoice No.:</label
          >
          <p>{{ history.invoice_number }}</p>

          <label for="cemetery_name" v-if="history.cemetery_name.length > 0"
            >Cemetery:</label
          >
          <p>{{ history.cemetery_name }}</p>

          <label
            for="contract_signed_date"
            v-if="history.contract_signed_date.length > 0"
            >Contract Signed Date:</label
          >
          <p>{{ history.contract_signed_date }}</p>

          <label
            for="contract_due_date"
            v-if="history.contract_due_date.length > 0"
            >Contract Due Date:</label
          >
          <p>{{ history.contract_due_date }}</p>

          <label
            for="request_plan_date"
            v-if="history.request_plan_date.length > 0"
            >Plan Request Date:</label
          >
          <p>{{ history.request_plan_date }}</p>

          <label
            for="sent_to_client_date"
            v-if="history.sent_to_client_date.length > 0"
            >Plan Sent:</label
          >
          <p>{{ history.sent_to_client_date }}</p>

          <label
            for="plan_signed_date"
            v-if="history.plan_signed_date.length > 0"
            >Plan Signed Date:</label
          >
          <p>{{ history.plan_signed_date }}</p>

          <label
            for="permit_sent_date"
            v-if="history.permit_sent_date.length > 0"
            >Permit Sent Date:</label
          >
          <p>{{ history.permit_sent_date }}</p>

          <label
            for="permit_approved_date"
            v-if="history.permit_approved_date.length > 0"
            >Permit Received Date:</label
          >
          <p>{{ history.permit_approved_date }}</p>

          <label for="photo_sent_date" v-if="history.photo_sent_date.length > 0"
            >Photo Sent Date:</label
          >
          <p>{{ history.photo_sent_date }}</p>

          <label
            for="photo_approved_date"
            v-if="history.photo_approved_date.length > 0"
            >Photo Received Date:</label
          >
          <p>{{ history.photo_approved_date }}</p>

          <label
            for="order_placed_date"
            v-if="history.order_placed_date.length > 0"
            >Order Placed Date:</label
          >
          <p>{{ history.order_placed_date }}</p>

          <!-- <label
            for="order_received_date"
            v-if="history.order_received_date.length > 0"
            >Order Placed Date:</label
          >
          <p>{{ history.order_received_date }}</p> -->

          <label
            for="foundation_ordered_date"
            v-if="history.foundation_ordered_date.length > 0"
            >Foundation Ordered Date:</label
          >
          <p>{{ history.foundation_ordered_date }}</p>

          <label
            for="accessory_ordered_date"
            v-if="history.accessory_ordered_date.length > 0"
            >Accessory Ordered Date:</label
          >
          <p>{{ history.accessory_ordered_date }}</p>

          <label
            for="inscription_got_date"
            v-if="history.inscription_got_date.length > 0"
            >Inscription Got Date:</label
          >
          <p>{{ history.inscription_got_date }}</p>

          <label
            for="inscription_sent_date"
            v-if="history.inscription_sent_date.length > 0"
            >Inscription Sent Date:</label
          >
          <p>{{ history.inscription_sent_date }}</p>

          <label
            for="inscription_signed_date"
            v-if="history.inscription_signed_date.length > 0"
            >Inscription Signed Date:</label
          >
          <p>{{ history.inscription_signed_date }}</p>

          <label
            for="inscription_booked_date"
            v-if="history.inscription_booked_date.length > 0"
            >Inscription Booked Date:</label
          >
          <p>{{ history.inscription_booked_date }}</p>

          <label
            for="installation_booked_date"
            v-if="history.installation_booked_date.length > 0"
            >Installation Booked Date:</label
          >
          <p>{{ history.installation_booked_date }}</p>

          <label for="follower" v-if="history.follower.length > 0"
            >Who is following:</label
          >
          <p>{{ history.follower }}</p>

          <label for="description" v-if="history.description.length > 0"
            >Description:</label
          >
          <p>{{ history.description }}</p>
        </b-collapse>
      </div>
    </b-modal>

    <b-modal id="modal-inscription-dates" hide-footer hide-header title="Inscription">
      <div>
        <h4>Inscription</h4>
        <b-form-checkbox
          id="inscription_not_required"
          v-model.trim="viewed_follow_up_report.inscription.inscription_not_required"
          name="inscription_not_required"
          :value="true"
          :unchecked-value="false"
          >Not Required</b-form-checkbox>
      </div>
      <hr class="mb-1">
      <DatesForm 
        v-bind:title="'Inscription'"
        v-bind:hide_header="true"
        v-bind:dates="viewed_follow_up_report.inscription.inscription_dates"
        v-bind:disabled="viewed_follow_up_report.inscription.inscription_not_required"
        :callBackFunction="update_inscription_dates">
      </DatesForm>

      <!-- <label for="inscription_container_no">Container No.</label>
      <b-input id="inscription_container_no"
        :disabled="viewed_follow_up_report.inscription.inscription_not_required"
        v-model.trim="viewed_follow_up_report.inscription.container_no"></b-input> -->

      <FileUploadPanel
        v-bind:id="viewed_follow_up_report.id"
        v-bind:files="viewed_follow_up_report.inscription.inscription_files"
        v-bind:disabled="viewed_follow_up_report.inscription.inscription_not_required"
        :callBackFunction="updateInscriptionFiles"
      >
      </FileUploadPanel>

      <label for="inscription_comment">Comment:</label>
      <b-textarea
        :disabled="viewed_follow_up_report.inscription.inscription_not_required"
        type="text"
        id="inscription_comment"
        v-model.trim="viewed_follow_up_report.inscription_comment"
      ></b-textarea>

      <div class="modal-footer mt-4">
        <b-button @click="hideModal('modal-inscription-dates')">
          Cancel
        </b-button>
        <b-button
          :disabled="isUpdating"
          variant="warning"
          @click="edit_follow_up_report"
        >
          <span v-if="!isUpdating">Update</span>
          <span v-if="isUpdating">
            <b-spinner small type="grow"></b-spinner>
            Updating...
          </span>
        </b-button>
      </div>
    </b-modal>

    <b-modal id="modal-accessory-dates" hide-footer hide-header title="Accessory">
      <div>
        <h4>Accessory</h4>
        <b-form-checkbox
          id="accessory_not_required"
          v-model.trim="viewed_follow_up_report.accessory.not_required"
          name="accessory_not_required"
          :value="true"
          :unchecked-value="false"
          >Not Required</b-form-checkbox>
      </div>
      <hr class="mb-1">
      
      <DatesForm 
        v-bind:title="viewed_follow_up_report.accessory.cross.name"
        v-bind:dates="viewed_follow_up_report.accessory.cross.cross_dates"
        v-bind:disabled="viewed_follow_up_report.accessory.cross.cross_not_required || viewed_follow_up_report.accessory.not_required"
        v-bind:not_required="viewed_follow_up_report.accessory.cross.cross_not_required"
        :updateNotRequired="update_accessory_cross_not_required"
        :callBackFunction="update_accessory_cross_dates">
      </DatesForm>

      <DatesForm 
        v-bind:title="viewed_follow_up_report.accessory.door.name"
        v-bind:dates="viewed_follow_up_report.accessory.door.door_dates"
        v-bind:disabled="viewed_follow_up_report.accessory.door.door_not_required || viewed_follow_up_report.accessory.not_required"
        v-bind:not_required="viewed_follow_up_report.accessory.door.door_not_required"
        :updateNotRequired="update_accessory_door_not_required"
        :callBackFunction="update_accessory_door_dates">
      </DatesForm>

      <DatesForm 
        v-bind:title="viewed_follow_up_report.accessory.decoration.name"
        v-bind:dates="viewed_follow_up_report.accessory.decoration.decoration_dates"
        v-bind:disabled="viewed_follow_up_report.accessory.decoration.decoration_not_required || viewed_follow_up_report.accessory.not_required"
        v-bind:not_required="viewed_follow_up_report.accessory.decoration.decoration_not_required"
        :updateNotRequired="update_accessory_decoration_not_required"
        :callBackFunction="update_accessory_decoration_dates">
      </DatesForm>

      <DatesForm 
        v-bind:title="viewed_follow_up_report.accessory.lantern.name"
        v-bind:dates="viewed_follow_up_report.accessory.lantern.lantern_dates"
        v-bind:disabled="viewed_follow_up_report.accessory.lantern.lantern_not_required || viewed_follow_up_report.accessory.not_required"
        v-bind:not_required="viewed_follow_up_report.accessory.lantern.lantern_not_required"
        :updateNotRequired="update_accessory_lantern_not_required"
        :callBackFunction="update_accessory_lantern_dates">
      </DatesForm>

      <DatesForm 
        v-bind:title="viewed_follow_up_report.accessory.photo_frame.name"
        v-bind:dates="viewed_follow_up_report.accessory.photo_frame.photo_frame_dates"
        v-bind:disabled="viewed_follow_up_report.accessory.photo_frame.photo_frame_not_required || viewed_follow_up_report.accessory.not_required"
        v-bind:not_required="viewed_follow_up_report.accessory.photo_frame.photo_frame_not_required"
        :updateNotRequired="update_accessory_photo_frame_not_required"
        :callBackFunction="update_accessory_photo_frame_dates">
      </DatesForm>

      <!-- <label for="inscription_container_no">Container No.</label>
      <b-input id="inscription_container_no"
        :disabled="viewed_follow_up_report.inscription.inscription_not_required"
        v-model.trim="viewed_follow_up_report.inscription.container_no"></b-input> -->

      <!-- <FileUploadPanel
        v-bind:id="viewed_follow_up_report.id"
        v-bind:files="viewed_follow_up_report.inscription.inscription_files"
        v-bind:disabled="viewed_follow_up_report.inscription.inscription_not_required"
        :callBackFunction="updateInscriptionFiles"
      >
      </FileUploadPanel> -->

      <h5 for="accessory_comment">Comment:</h5>
      <b-textarea
        :disabled="viewed_follow_up_report.accessory.not_required"
        type="text"
        id="accessory_comment"
        v-model.trim="viewed_follow_up_report.accessory.comment"
      ></b-textarea>

      <div class="modal-footer mt-4">
        <b-button @click="hideModal('modal-accessory-dates')">
          Cancel
        </b-button>
        <b-button
          :disabled="isUpdating"
          variant="warning"
          @click="edit_follow_up_report"
        >
          <span v-if="!isUpdating">Update</span>
          <span v-if="isUpdating">
            <b-spinner small type="grow"></b-spinner>
            Updating...
          </span>
        </b-button>
      </div>
    </b-modal>

    <!-- PHOTO MODAL -->
    <b-modal id="modal-photo" hide-footer hide-header>
      <div>
        <h4>Photo - {{viewed_follow_up_report.invoice_number}}</h4>
        <b-form-checkbox
          id="photo_not_required"
          v-model.trim="viewed_follow_up_report.photo.not_required"
          name="photo_not_required"
          :value="true"
          :unchecked-value="false"
          >Not Required</b-form-checkbox>
      </div>
      <hr class="mb-1">

      <DatesForm 
        v-bind:title="'Photo'"
        v-bind:hide_header="true"
        v-bind:dates="viewed_follow_up_report.photo.dates"
        v-bind:disabled="viewed_follow_up_report.photo.not_required"
        v-bind:not_required="viewed_follow_up_report.photo.not_required"
        :callBackFunction="update_photo_dates">
      </DatesForm>

      <label for="photo_shape">Shape:</label>
      <b-input
        :disabled="viewed_follow_up_report.photo.not_required"
        type="text"
        id="photo_shape"
        v-model.trim="viewed_follow_up_report.photo.shape"
      ></b-input>

      <label for="photo_size">Size:</label>
      <b-input
        :disabled="viewed_follow_up_report.photo.not_required"
        type="text"
        id="photo_size"
        v-model.trim="viewed_follow_up_report.photo.size"
      ></b-input>

      <label for="photo_colour">Colour:</label>
      <b-input
        :disabled="viewed_follow_up_report.photo.not_required"
        type="text"
        id="photo_colour"
        v-model.trim="viewed_follow_up_report.photo.colour"
      ></b-input>

      <label for="photo_quantity">Quantity:</label>
      <b-input
        :disabled="viewed_follow_up_report.photo.not_required"
        type="number"
        id="photo_quantity"
        v-model.trim="viewed_follow_up_report.photo.quantity"
      ></b-input>

      <label for="accessory_comment">Comment:</label>
      <b-textarea
        :disabled="viewed_follow_up_report.photo.not_required"
        type="text"
        id="accessory_comment"
        v-model.trim="viewed_follow_up_report.photo.comment"
      ></b-textarea>
      
      <div class="modal-footer mt-4">
        <b-button :disabled="viewed_follow_up_report.photo.not_required" 
          @click="showModal('modal-email-form')">Email</b-button>
        <b-button @click="hideModal('modal-photo')">
          Cancel
        </b-button>
        <b-button
          :disabled="isUpdating"
          variant="warning"
          @click="edit_follow_up_report"
        >
          <span v-if="!isUpdating">Update</span>
          <span v-if="isUpdating">
            <b-spinner small type="grow"></b-spinner>
            Updating...
          </span>
        </b-button>
      </div>
    </b-modal>

    <b-modal centered id="modal-email-form" hide-footer title="Email Form">
      <EmailForm
        v-bind:sender="user"
        v-bind:invoice_number="viewed_follow_up_report.invoice_number"
        v-bind:photo="viewed_follow_up_report.photo">
      </EmailForm>
    </b-modal>
    
  </div>
</template>

<script>
import firebase from "firebase/app";
import DatesForm from "../templates/FollowUpReport/DatesForm";
import FileUploadPanel from "../templates/FileUploadPanel.vue";
import EmailForm from '../templates/EmailForm.vue';
import * as _ from 'lodash';

export default {
  components: {
    DatesForm,
    EmailForm,
    FileUploadPanel,
  },
  computed: {
    rows: {
      get() {
        if (this.displayed_reports.length == 0) {
          return 100;
        } else {
          return this.displayed_reports.length;
        }
      },
      set(newRows) {
        return newRows;
      },
    },
  },
  created() {
    this.set_global_date();
    this.showAllReports == 'false';
    this.tableIsBusy = true;
    this.time_range.end = this.today;

    var new_date = new Date(this.today);
    new_date.setDate(new_date.getDate() - 25 * 7);
    this.time_range.start =
      new_date.getFullYear() +
      "-" +
      (new_date.getMonth() + 1) +
      "-" +
      new_date.getDate();

    if (this.user.role == "sales") {
      firebase
        .firestore()
        .collection("follow_up_reports")
        .where("follower", "==", this.user.name)
        .where("job_complete_date", "==", "")
        .where("created_date_timestamp", ">=", new_date)
        .orderBy("created_date_timestamp", "desc")
        // .orderBy("invoice_number")
        .onSnapshot((collection) => {
          this.active_reports = [];
          this.active_reports = collection.docs.map((doc) => doc.data());
          if (this.showAllReports == 'false') this.displayed_reports = this.active_reports;
          //console.log('active updated');
        });
    } else {
      if (this.user.name == 'Operator1') {
        this.new_follow_up_report.follower = 'Jacky';
        firebase
        .firestore()
        .collection("follow_up_reports")
        .where("job_complete_date", "==", "")
        .where("created_date_timestamp", ">=", new_date)
        .orderBy("created_date_timestamp", "desc")
        // .orderBy("invoice_number")
        .onSnapshot((collection) => {
          this.active_reports = [];
          this.active_reports = collection.docs.map((doc) => doc.data());
          if (this.showAllReports == 'false') this.displayed_reports = this.active_reports;
        });
      } else {
        firebase
          .firestore()
          .collection("follow_up_reports")
          .where("job_complete_date", "==", "")
          .where("created_date_timestamp", ">=", new_date)
          .orderBy("created_date_timestamp", "desc")
          // .orderBy("invoice_number")
          .onSnapshot((collection) => {
            this.active_reports = [];
            this.active_reports = collection.docs.map((doc) => doc.data());
            if (this.showAllReports == 'false') this.displayed_reports = this.active_reports;
            //console.log('active updated');
          });
      }
    }

    if (this.user.role == "sales") {
      firebase
        .firestore()
        .collection("follow_up_reports")
        .where("follower", "==", this.user.name)
        .where("created_date_timestamp", ">=", new_date)
        .orderBy("created_date_timestamp", "desc")
        // .orderBy("invoice_number")
        .onSnapshot((collection) => {
          this.follow_up_reports = [];
          this.follow_up_reports = collection.docs.map((doc) => doc.data());
          if (this.showAllReports == 'true') this.displayed_reports = this.follow_up_reports;
          this.tableIsBusy = false;
          //console.log('all updated');
        });
    } else {
      firebase
        .firestore()
        .collection("follow_up_reports")
        .where("created_date_timestamp", ">=", new_date)
        .orderBy("created_date_timestamp", "desc")
        // .orderBy("invoice_number")
        .onSnapshot((collection) => {
          this.follow_up_reports = [];
          this.follow_up_reports = collection.docs.map((doc) => doc.data());
          if (this.showAllReports == 'true') this.displayed_reports = this.follow_up_reports;
          this.tableIsBusy = false;
          //console.log('all updated');
        });
    }

    firebase
      .firestore()
      .collection("saless")
      .orderBy("name", "asc")
      .onSnapshot((collection) => {
        this.sales = [];
        this.sales_names = [];
        this.sales = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.sales.length; i++) {
          this.sales_names.push(this.sales[i].name);
        }
      });

    firebase
      .firestore()
      .collection("cemeteries")
      .orderBy("name", "asc")
      .onSnapshot((collection) => {
        this.cemeteries = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.cemeteries.length; i++) {
          this.cemetery_names.push(this.cemeteries[i].name);
        }

        this.cemetery_names.push("others");
      });
  },
  props: {
    user: Object,
  },
  data() {
    return {
      time_range: {
        start: "",
        end: "",
      },
      time_filtered_reports: [],
      funeral_providers: [],
      funeral_provider_names: [],
      lead_sources: [],
      lead_source_names: [],
      sales: [],
      sales_names: [],
      perPage: 20,
      currentPage: 1,
      filterCriteria: "",
      tableIsBusy: false,
      deleted_follow_up_report_id: "",
      follow_up_report_fields: [
        { key: "invoice_number", label: "Invoice #", sortable: true },
        { key: "follower", label: "Sales" },
        { key: "contract_signed_date", label: "Signed", sortable: true },
        { key: "contract_due_date", label: "Due", sortable: true },
        { key: "request_plan_date", label: "Request" },
        { key: "sent_to_client_date", label: "Sent" },
        { key: "plan_signed_date", label: "Signed" },
        { key: "permit_sent_date", label: "Sent" },
        { key: "permit_approved_date", label: "Received" },
        { key: "order_placed_date", label: "Ordered" },
        { key: "order_received_date", label: "Received"},
        { key: "photo", label: "Photo"},
        // { key: "photo_sent_date", label: "Photo Sent" },
        // { key: "photo_approved_date", label: "Photo Received" },
        { key: "foundation_ordered_date", label: "Ordered" },
        { key: "foundation_done_date", label: "Done" },
        { key: "foundation_container_number", label: "Container #"},
        { key: "inscription_dates", label: "Inscription"},
        // { key: "inscription_got_date", label: "Writing recd" },
        // { key: "inscription_sent_date", label: "Inscript Sent" },
        // { key: "inscription_signed_date", label: "Inscript Signed" },
        // { key: "inscription_booked_date", label: "Inscript Booked" },
        { key: "accessory", label: "Accessory"},
        // { key: "accessory_ordered_date", label: "Accessory Ordered" },
        // { key: "accessory_received_date", label: "Accessory Received" },
        { key: "final_payment_date", label: "Final Payment"},
        { key: "installation_booked_date", label: "Booked" },
        { key: "job_complete_date", label: "Complete" },
        { key: "invoice_number_2", label: "Invoice #" },
      ],
      displayed_reports: [],
      follow_up_reports: [],
      active_reports: [],
      showAllReports: "false",
      new_follow_up_report: {
        final_payment_date: "",
        accessory_ordered_date: "",
        accessory_ordered_date_not_required: false,
        accessory_ordered_date_comment: "",
        accessory_received_date: "",
        accessory_received_date_not_required: false,
        accessory_received_date_comment: "",
        branch: "",
        cemetery_name: "",
        contract_due_date: "",
        contract_signed_date: "",
        created_by: "",
        created_date: "",
        description: "",
        follower: this.user.name,
        foundation_not_required: false,
        foundation_ordered_date: "",
        foundation_ordered_date_comment: "",
        foundation_done_date: "",
        foundation_done_date_comment: "",
        foundation_container_number: "",
        id: "",
        invoice_number: "",
        inscription: {
          inscription_progress: 0,
          inscription_required_item_number: 4,
          inscription_not_required: false,
          // inscription_container_no: "",
          inscription_comment: "",
          inscription_files: [],
          inscription_dates: [
            {name: "Writing Recd", date: ""},
            {name: "Sent", date: ""},
            {name: "Signed", date: ""},
            {name: "Booked", date: ""},
          ],
        },
        accessory: {
          progress: 0,
          required_item_number: 5,
          not_required: false,
          comment: "",
          cross: {
            name: "Cross",
            cross_not_required: false,
            cross_progress: 0,
            cross_required_item_number: 2,
            cross_dates: [
              {name: "Ordered", date: ""},
              {name: "Received", date: ""},
            ]
          },
          door: {
            name: "Door",
            door_not_required: false,
            door_progress: 0,
            door_required_item_number: 2,
            door_dates: [
              {name: "Ordered", date: ""},
              {name: "Received", date: ""},
            ],
          },
          lantern: {
            name: "Lantern",
            lantern_not_required: false,
            lantern_progress: 0,
            lantern_required_item_number: 2,
            lantern_dates: [
              {name: "Ordered", date: ""},
              {name: "Received", date: ""},
            ],
          },
          decoration: {
            name: "Decoration",
            decoration_not_required: false,
            decoration_progress: 0,
            decoration_required_item_number: 2,
            decoration_dates: [
              {name: "Ordered", date: ""},
              {name: "Received", date: ""},
            ],
          },
          photo_frame: {
            name: "Photo Frame",
            photo_frame_not_required: false,
            photo_frame_progress: 0,
            photo_frame_required_item_number: 2,
            photo_frame_dates: [
              {name: "Ordered", date: ""},
              {name: "Received", date: ""},
            ],
          },
        },
        photo: {
          dates: [
            {name: "Ordered", date: ""},
            {name: "Received", date: ""},
          ],
          shape: "",
          size: "",
          quantity: "",
          colour: "",
          not_required: false,
          required_item_number: 2,
          progress: 0,
          files: [],
        },
        inscription_got_date: "",
        inscription_got_date_not_required: false,
        inscription_got_date_comment: "",
        inscription_sent_date: "",
        inscription_sent_date_not_required: false,
        inscription_sent_date_comment: "",
        inscription_signed_date: "",
        inscription_signed_date_not_required: false,
        inscription_signed_date_comment: "",
        inscription_booked_date: "",
        inscription_booked_date_not_required: false,
        inscription_booked_date_comment: "",
        installation_booked_date: "",
        installation_booked_not_required: false,
        installation_booked_date_comment: "",
        stone_order_not_required: false,
        order_placed_date: "",
        order_placed_date_comment: "",
        order_received_date: "",
        order_received_date_comment: "",
        plan_not_required: false,
        plan_signed_date: "",
        plan_signed_date_comment: "",
        request_plan_date: "",
        request_plan_date_comment: "",
        sent_to_client_date: "",
        sent_to_client_date_comment: "",
        permit_not_required: false,
        permit_sent_date: "",
        permit_sent_date_comment: "",
        permit_approved_date: "",
        permit_approved_date_comment: "",
        photo_sent_date: "",
        photo_sent_date_not_required: false,
        photo_sent_date_comment: "",
        photo_approved_date: "",
        photo_approved_date_not_required: false,
        photo_approved_date_comment: "",
        job_complete_date: "",
        edit_histories: [],
      },
      viewed_follow_up_report: {
        final_payment_date: "",
        accessory_ordered_date: "",
        accessory_ordered_date_not_required: false,
        accessory_ordered_date_comment: "",
        accessory_received_date: "",
        accessory_received_date_not_required: false,
        accessory_received_date_comment: "",
        branch: "",
        cemetery_name: "",
        contract_due_date: "",
        contract_signed_date: "",
        created_by: "",
        created_date: "",
        description: "",
        follower: this.user.name,
        foundation_not_required: false,
        foundation_ordered_date: "",
        foundation_ordered_date_comment: "",
        foundation_done_date: "",
        foundation_done_date_comment: "",
        foundation_container_number: "",
        id: "",
        invoice_number: "",
        inscription: {
          inscription_progress: 0,
          inscription_required_item_number: 4,
          inscription_not_required: false,
          // inscription_container_no: "",
          inscription_comment: "",
          inscription_files: [],
          inscription_dates: [
            {name: "Writing Recd", date: ""},
            {name: "Sent", date: ""},
            {name: "Signed", date: ""},
            {name: "Booked", date: ""},
          ],
        },
        accessory: {
          progress: 0,
          required_item_number: 5,
          not_required: false,
          comment: "",
          cross: {
            name: "Cross",
            cross_not_required: false,
            cross_progress: 0,
            cross_required_item_number: 2,
            cross_dates: [
              {name: "Ordered", date: ""},
              {name: "Received", date: ""},
            ]
          },
          door: {
            name: "Door",
            door_not_required: false,
            door_progress: 0,
            door_required_item_number: 2,
            door_dates: [
              {name: "Ordered", date: ""},
              {name: "Received", date: ""},
            ],
          },
          lantern: {
            name: "Lantern",
            lantern_not_required: false,
            lantern_progress: 0,
            lantern_required_item_number: 2,
            lantern_dates: [
              {name: "Ordered", date: ""},
              {name: "Received", date: ""},
            ],
          },
          decoration: {
            name: "Decoration",
            decoration_not_required: false,
            decoration_progress: 0,
            decoration_required_item_number: 2,
            decoration_dates: [
              {name: "Ordered", date: ""},
              {name: "Received", date: ""},
            ],
          },
          photo_frame: {
            name: "Photo Frame",
            photo_frame_not_required: false,
            photo_frame_progress: 0,
            photo_frame_required_item_number: 2,
            photo_frame_dates: [
              {name: "Ordered", date: ""},
              {name: "Received", date: ""},
            ],
          },
        },
        photo: {
          dates: [
            {name: "Ordered", date: ""},
            {name: "Received", date: ""},
          ],
          shape: "",
          size: "",
          quantity: "",
          colour: "",
          not_required: false,
          required_item_number: 2,
          progress: 0,
          files: [],
        },
        inscription_got_date: "",
        inscription_got_date_not_required: false,
        inscription_got_date_comment: "",
        inscription_sent_date: "",
        inscription_sent_date_not_required: false,
        inscription_sent_date_comment: "",
        inscription_signed_date: "",
        inscription_signed_date_not_required: false,
        inscription_signed_date_comment: "",
        inscription_booked_date: "",
        inscription_booked_date_not_required: false,
        inscription_booked_date_comment: "",
        installation_booked_date: "",
        installation_booked_not_required: false,
        installation_booked_date_comment: "",
        stone_order_not_required: false,
        order_placed_date: "",
        order_placed_date_comment: "",
        order_received_date: "",
        order_received_date_comment: "",
        plan_signed_date: "",
        plan_not_required: false,
        plan_signed_date_comment: "",
        permit_not_required: false,
        permit_sent_date: "",
        permit_sent_date_comment: "",
        permit_approved_date: "",
        permit_approved_date_comment: "",
        photo_sent_date: "",
        photo_sent_date_not_required: false,
        photo_sent_date_comment: "",
        photo_approved_date: "",
        photo_approved_date_not_required: false,
        photo_approved_date_comment: "",
        request_plan_date: "",
        request_plan_date_comment: "",
        sent_to_client_date: "",
        sent_to_client_date_comment: "",
        job_complete_date: "",
        edit_histories: [],
        viewing_new_item: false,
        temp_item: null,
      },
      cemeteries: [],
      cemetery_names: [],
      status_names: ["success", "pending", "fail"],
      isSubmitting: false,
      isUpdating: false,
      isDeleting: false,
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      modal_id: "",
      filterOn: [
        "invoice_number",
        "follower",
        // "contract_signed_date",
        // "contract_due_date",
        // "request_plan_date",
        // "sent_to_client_date",
        // "plan_signed_date",
        // "permit_sent_date",
        // "permit_approved_date",
        // "order_placed_date",
        // "order_received_date",
        // "foundation_ordered_date",
        // "foundation_done_date",
        // "installation_booked_date",
        // "job_complete_date",
      ],
    };
  },
  watch: {
    showAllReports(newShowAllReports) {
      if (newShowAllReports == "true") {
        this.displayed_reports = this.follow_up_reports;
      } else {
        this.displayed_reports = this.active_reports;
      }
    }
  },
  methods: {
    myRowClickHandler(item) {
      this.viewing_new_item = true;
      this.temp_item = Object.assign({}, item);
      this.viewed_follow_up_report = item;
      this.showModal("modal-view-follow-up-report");
      console.log(item);
    },
    delete_follow_up_report(id) {
      if (this.user.role != "admin") {
        alert("You do not have authority.");
      } else {
        this.deleted_follow_up_report_id = id;
        this.showModal("modal-delete-follow-up-report");
      }
    },
    delete_follow_up_report_task() {
      this.isDeleting = true;
      this.hideModal("modal-view-follow-up-report");

      firebase
        .firestore()
        .collection("follow_up_reports")
        .doc(this.deleted_follow_up_report_id)
        .delete()
        .then(() => {
          alert("delete successfully");
          this.isDeleting = false;
          this.hideModal("modal-delete-follow-up-report");
        });
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    add_follow_up_report() {
      this.isSubmitting = true;
      const new_follow_up_report_ref = firebase
        .firestore()
        .collection("follow_up_reports")
        .doc();

      if (this.new_follow_up_report.contract_signed_date != "") {
        var new_date = new Date(this.new_follow_up_report.contract_signed_date);
        new_date.setDate(new_date.getDate() + 16 * 7);
        this.new_follow_up_report.contract_due_date =
          new_date.getFullYear() +
          "-" +
          (new_date.getMonth() + 1) +
          "-" +
          new_date.getDate();
      }
      this.new_follow_up_report.id = new_follow_up_report_ref.id;
      this.new_follow_up_report.created_date = this.today;
      this.new_follow_up_report.created_date_timestamp = new Date(this.today);
      this.new_follow_up_report.year_month = this.new_follow_up_report.created_date.substring(
        0,
        7
      );
      this.new_follow_up_report.day = parseInt(
        this.new_follow_up_report.created_date.substring(8, 10)
      );
      this.new_follow_up_report.created_by = this.user;
      this.new_follow_up_report.created_by_name = this.user.name;
      this.new_follow_up_report.follower_info = this.sales[
        this.sales_names.indexOf(this.new_follow_up_report.follower)
      ];
      this.new_follow_up_report.edit_histories.push({
        accessory_ordered_date: this.new_follow_up_report
          .accessory_ordered_date,
        accessory_received_date: this.new_follow_up_report
          .accessory_received_date,
        branch: this.new_follow_up_report.branch,
        cemetery_name: this.new_follow_up_report.cemetery_name,
        contract_due_date: this.new_follow_up_report.contract_due_date,
        contract_signed_date: this.new_follow_up_report.contract_signed_date,
        created_by: this.new_follow_up_report.created_by,
        created_date: this.new_follow_up_report.created_date,
        description: this.new_follow_up_report.description,
        follower: this.new_follow_up_report.follower,
        foundation_ordered_date: this.new_follow_up_report
          .foundation_ordered_date,
        foundation_done_date: this.new_follow_up_report.foundation_done_date,
        foundation_container_number: "",
        id: this.new_follow_up_report.id,
        invoice_number: this.new_follow_up_report.invoice_number,
        inscription_got_date: this.new_follow_up_report.inscription_got_date,
        inscription_sent_date: this.new_follow_up_report.inscription_sent_date,
        inscription_signed_date: this.new_follow_up_report
          .inscription_signed_date,
        inscription_booked_date: this.new_follow_up_report
          .inscription_booked_date,
        installation_booked_date: this.new_follow_up_report
          .installation_booked_date,
        order_placed_date: this.new_follow_up_report.order_placed_date,
        order_received_date: this.new_follow_up_report.order_received_date,
        plan_signed_date: this.new_follow_up_report.plan_signed_date,
        permit_sent_date: this.new_follow_up_report.permit_sent_date,
        permit_approved_date: this.new_follow_up_report.permit_approved_date,
        photo_sent_date: this.new_follow_up_report.photo_sent_date,
        photo_approved_date: this.new_follow_up_report.photo_approved_date,
        request_plan_date: this.new_follow_up_report.request_plan_date,
        sent_to_client_date: this.new_follow_up_report.sent_to_client_date,
        job_complete_date: this.new_follow_up_report.job_complete_date,
        edit_by: this.user.name,
        edit_on: this.today,
        inscription: {
          inscription_progress: 0,
          inscription_required_item_number: 4,
          inscription_not_required: false,
          // inscription_container_no: "",
          inscription_comment: "",
          inscription_files: [],
          inscription_dates: [
            {name: "Writing Recd", date: ""},
            {name: "Sent", date: ""},
            {name: "Signed", date: ""},
            {name: "Booked", date: ""},
          ],
        },
      });

      console.log(this.new_follow_up_report);
      new_follow_up_report_ref
        .set(this.new_follow_up_report, { merge: true })
        .then(() => {
          this.hideModal("modal-add-follow-up-report");
          const recipient = this.sales[
            this.sales_names.indexOf(this.new_follow_up_report.follower)
          ];

          var email = {
            to: [recipient.email],
            message: {
              subject: "A follow up report has been allocated to you",
              text:
                "Hi " +
                recipient.name +
                ", \n" +
                "The details of the follow up report are as follows:\n" +
                "Created by: " +
                this.new_follow_up_report.created_by_name +
                "\n" +
                "Invoice #: " +
                this.new_follow_up_report.invoice_number +
                "\n",
            },
          };

          firebase
            .firestore()
            .collection("mail")
            .add(email);

          this.new_follow_up_report = {
            final_payment_date: "",
            accessory_ordered_date: "",
            accessory_ordered_date_not_required: false,
            accessory_ordered_date_comment: "",
            accessory_received_date: "",
            accessory_received_date_not_required: false,
            accessory_received_date_comment: "",
            branch: "",
            cemetery_name: "",
            contract_due_date: "",
            contract_signed_date: "",
            created_by: "",
            created_date: "",
            description: "",
            follower: this.user.name,
            foundation_not_required: false,
            foundation_ordered_date: "",
            foundation_ordered_date_comment: "",
            foundation_done_date: "",
            foundation_done_date_comment: "",
            id: "",
            invoice_number: "",
            inscription: {
              inscription_progress: 0,
              inscription_required_item_number: 4,
              inscription_not_required: false,
              // inscription_container_no: "",
              inscription_comment: "",
              inscription_files: [],
              inscription_dates: [
                {name: "Writing Recd", date: ""},
                {name: "Sent", date: ""},
                {name: "Signed", date: ""},
                {name: "Booked", date: ""},
              ],
            },
            accessory: {
              progress: 0,
              required_item_number: 5,
              not_required: false,
              comment: "",
              cross: {
                name: "Cross",
                cross_not_required: false,
                cross_progress: 0,
                cross_required_item_number: 2,
                cross_dates: [
                  {name: "Ordered", date: ""},
                  {name: "Received", date: ""},
                ]
              },
              door: {
                name: "Door",
                door_not_required: false,
                door_progress: 0,
                door_required_item_number: 2,
                door_dates: [
                  {name: "Ordered", date: ""},
                  {name: "Received", date: ""},
                ],
              },
              lantern: {
                name: "Lantern",
                lantern_not_required: false,
                lantern_progress: 0,
                lantern_required_item_number: 2,
                lantern_dates: [
                  {name: "Ordered", date: ""},
                  {name: "Received", date: ""},
                ],
              },
              decoration: {
                name: "Decoration",
                decoration_not_required: false,
                decoration_progress: 0,
                decoration_required_item_number: 2,
                decoration_dates: [
                  {name: "Ordered", date: ""},
                  {name: "Received", date: ""},
                ],
              },
              photo_frame: {
                name: "Photo Frame",
                photo_frame_not_required: false,
                photo_frame_progress: 0,
                photo_frame_required_item_number: 2,
                photo_frame_dates: [
                  {name: "Ordered", date: ""},
                  {name: "Received", date: ""},
                ],
              },
            },
            photo: {
              dates: [
                {name: "Ordered", date: ""},
                {name: "Received", date: ""},
              ],
              shape: "",
              size: "",
              quantity: "",
              colour: "",
              not_required: false,
              required_item_number: 2,
              progress: 0,
              files: [],
            },
            inscription_got_date: "",
            inscription_got_date_not_required: false,
            inscription_got_date_comment: "",
            inscription_sent_date: "",
            inscription_sent_date_not_required: false,
            inscription_sent_date_comment: "",
            inscription_signed_date: "",
            inscription_signed_date_not_required: false,
            inscription_signed_date_comment: "",
            inscription_booked_date: "",
            inscription_booked_date_not_required: false,
            inscription_booked_date_comment: "",
            installation_booked_date: "",
            installation_booked_not_required: false,
            installation_booked_date_comment: "",
            stone_order_not_required: false,
            order_placed_date: "",
            order_placed_date_comment: "",
            order_received_date: "",
            order_received_date_comment: "",
            plan_signed_date: "",
            plan_not_required: false,
            plan_signed_date_comment: "",
            permit_not_required: false,
            permit_sent_date: "",
            permit_sent_date_comment: "",
            permit_approved_date: "",
            permit_approved_date_comment: "",
            photo_sent_date: "",
            photo_sent_date_not_required: false,
            photo_sent_date_comment: "",
            photo_approved_date: "",
            photo_approved_date_not_required: false,
            photo_approved_date_comment: "",
            request_plan_date: "",
            request_plan_date_comment: "",
            sent_to_client_date: "",
            sent_to_client_date_comment: "",
            job_complete_date: "",
            edit_histories: [],
          };

          this.new_follow_up_report.follower = 'Jacky';
          this.isSubmitting = false;
        });
    },
    set_global_date() {
      var date_time = new Date();
      var dd = String(date_time.getDate()).padStart(2, "0");
      var mm = String(date_time.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = date_time.getFullYear();

      this.today = yyyy + "-" + mm + "-" + dd;
      this.new_follow_up_report.date = this.today;
    },
    view_follow_up_report(follow_up_report) {
      this.viewed_follow_up_report = follow_up_report;
      this.showModal("modal-view-follow-up-report");
    },
    edit_follow_up_report() {
      this.isUpdating = true;
      this.viewed_follow_up_report.reminded = false;
      this.viewed_follow_up_report.edit_histories.push({
        accessory_ordered_date: this.viewed_follow_up_report
          .accessory_ordered_date,
        accessory_received_date: this.viewed_follow_up_report
          .accessory_received_date,
        branch: this.viewed_follow_up_report.branch,
        cemetery_name: this.viewed_follow_up_report.cemetery_name,
        contract_due_date: this.viewed_follow_up_report.contract_due_date,
        contract_signed_date: this.viewed_follow_up_report.contract_signed_date,
        created_by: this.viewed_follow_up_report.created_by,
        created_date: this.viewed_follow_up_report.created_date,
        description: this.viewed_follow_up_report.description,
        follower: this.viewed_follow_up_report.follower,
        foundation_ordered_date: this.viewed_follow_up_report
          .foundation_ordered_date,
        foundation_done_date: this.new_follow_up_report.foundation_done_date,
        id: this.viewed_follow_up_report.id,
        invoice_number: this.viewed_follow_up_report.invoice_number,
        inscription_got_date: this.viewed_follow_up_report.inscription_got_date,
        inscription_sent_date: this.viewed_follow_up_report
          .inscription_sent_date,
        inscription_signed_date: this.viewed_follow_up_report
          .inscription_signed_date,
        inscription_booked_date: this.viewed_follow_up_report
          .inscription_booked_date,
        installation_booked_date: this.viewed_follow_up_report
          .installation_booked_date,
        order_placed_date: this.viewed_follow_up_report.order_placed_date,
        plan_signed_date: this.viewed_follow_up_report.plan_signed_date,
        permit_sent_date: this.viewed_follow_up_report.permit_sent_date,
        permit_approved_date: this.viewed_follow_up_report.permit_approved_date,
        photo_sent_date: this.viewed_follow_up_report.photo_sent_date,
        photo_approved_date: this.viewed_follow_up_report.photo_approved_date,
        request_plan_date: this.viewed_follow_up_report.request_plan_date,
        sent_to_client_date: this.viewed_follow_up_report.sent_to_client_date,
        edit_by: this.user.name,
        edit_on: this.today,
      });
      firebase
        .firestore()
        .collection("follow_up_reports")
        .doc(this.viewed_follow_up_report.id)
        .set(this.viewed_follow_up_report, { merge: true })
        .then(() => {
          //this.hideModal(this.modal_id);
          //console.log(this.viewed_follow_up_report);
          alert("Modify successfully");
          this.isUpdating = false;
        });
    },
    submitTimeRange() {
      var start = null;
      var end = null;

      if (this.time_range.start == "" && this.time_range.end == "") return;

      if (this.time_range.start != "") {
        start = new Date(this.time_range.start);
      }

      if (this.time_range.end != "") {
        end = new Date(this.time_range.end);
      }

      if (this.time_range.start == "" && this.time_range.end != "") {
        if (this.user.name == 'Operator1' || this.user.role == 'admin') {
          firebase
            .firestore()
            .collection("follow_up_reports")
            .where("created_date_timestamp", "<=", end)
            .orderBy("created_date_timestamp", "desc")
            .onSnapshot((collection) => {
              this.time_filtered_reports = [];
              this.time_filtered_reports = collection.docs.map((doc) =>
                doc.data()
              );
              this.displayed_reports = this.time_filtered_reports;
            });
        } else {
          firebase
            .firestore()
            .collection("follow_up_reports")
            .where('follower', '==', this.user.name)
            .where("created_date_timestamp", "<=", end)
            .orderBy("created_date_timestamp", "desc")
            .onSnapshot((collection) => {
              this.time_filtered_reports = [];
              this.time_filtered_reports = collection.docs.map((doc) =>
                doc.data()
              );
              this.displayed_reports = this.time_filtered_reports;
            });
        }
      }

      if (this.time_range.start != "" && this.time_range.end == "") {
        // console.log(start);
        if (this.user.name == 'Operator1' || this.user.role == 'admin') {
          firebase
            .firestore()
            .collection("follow_up_reports")
            .where("created_date_timestamp", ">=", start)
            .orderBy("created_date_timestamp", "desc")
            .onSnapshot((collection) => {
              this.time_filtered_reports = [];
              this.time_filtered_reports = collection.docs.map((doc) =>
                doc.data()
              );
              this.displayed_reports = this.time_filtered_reports;
            });
        } else {
          firebase
            .firestore()
            .collection("follow_up_reports")
            .where('follower', '==', this.user.name)
            .where("created_date_timestamp", ">=", start)
            .orderBy("created_date_timestamp", "desc")
            .onSnapshot((collection) => {
              this.time_filtered_reports = [];
              this.time_filtered_reports = collection.docs.map((doc) =>
                doc.data()
              );
              this.displayed_reports = this.time_filtered_reports;
            });
        }
      }

      if (this.time_range.start != "" && this.time_range.end != "") {
        if (this.user.name == 'Operator1' || this.user.role == 'admin') {
          firebase
            .firestore()
            .collection("follow_up_reports")
            .where("created_date_timestamp", ">=", start)
            .where("created_date_timestamp", "<=", end)
            .orderBy("created_date_timestamp", "desc")
            .onSnapshot((collection) => {
              this.time_filtered_reports = [];
              this.time_filtered_reports = collection.docs.map((doc) =>
                doc.data()
              );
              this.displayed_reports = this.time_filtered_reports;
            });
        } else {
          firebase
            .firestore()
            .collection("follow_up_reports")
            .where('follower', '==', this.user.name)
            .where("created_date_timestamp", ">=", start)
            .where("created_date_timestamp", "<=", end)
            .orderBy("created_date_timestamp", "desc")
            .onSnapshot((collection) => {
              this.time_filtered_reports = [];
              this.time_filtered_reports = collection.docs.map((doc) =>
                doc.data()
              );
              this.displayed_reports = this.time_filtered_reports;
            });
        }
      }
    },
    resetTimeRange() {
      this.time_range.start = "";
      this.time_range.end = "";
      this.displayed_reports = this.follow_up_reports;
    },
    showEditHistories() {},
    cleanFilterInfo() {
      this.filterCriteria = "";
    },
    formatDate(dateString) {
      if (!dateString || dateString == "") return "";
      const ymd = dateString.split("-");
      const monthString = ymd[1].charAt(0) == "0" ? ymd[1].slice(1) : ymd[1];
      return ymd[2] + "-" + this.monthNames[parseInt(monthString) - 1];
    },
    follower_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-follower");
      this.modal_id = "modal-edit-follower";
    },
    contract_signed_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-contract-signed");
      this.modal_id = "modal-edit-contract-signed";
    },
    contract_due_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-contract-due");
      this.modal_id = "modal-edit-contract-due";
    },
    request_plan_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-request-plan");
      this.modal_id = "modal-edit-request-plan";
    },
    sent_to_client_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-sent-to-client");
      this.modal_id = "modal-edit-sent-to-client";
    },
    plan_signed_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-plan-signed");
      this.modal_id = "modal-edit-plan-signed";
    },
    permit_sent_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-permit-sent");
      this.modal_id = "modal-edit-permit-sent";
    },
    permit_approved_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-permit-received");
      this.modal_id = "modal-edit-permit-received";
    },
    order_placed_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-order-placed-date");
      this.modal_id = "modal-edit-order-placed-date";
    },
    order_received_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-order-received-date");
      this.modal_id = "modal-edit-order-received-date";
    },
    photo_sent_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-photo-sent-date");
      this.modal_id = "modal-edit-photo-sent-date";
    },
    photo_approved_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-photo-approved-date");
      this.modal_id = "modal-edit-photo-approved-date";
    },
    foundation_ordered_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-foundation-ordered-date");
      this.modal_id = "modal-edit-foundation-ordered-date";
    },
    foundation_done_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-foundation-done-date");
      this.modal_id = "modal-edit-foundation-done-date";
    },
    foundation_container_number_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-foundation-container-number");
      this.modal_id = "modal-edit-foundation-container-number";
    },
    inscription_got_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-inscription-got-date");
      this.modal_id = "modal-edit-inscription-got-date";
    },
    inscription_sent_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-inscription-sent-date");
      this.modal_id = "modal-edit-inscription-sent-date";
    },
    inscription_signed_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-inscription-signed-date");
      this.modal_id = "modal-edit-inscription-signed-date";
    },
    inscription_booked_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-inscription-booked-date");
      this.modal_id = "modal-edit-inscription-booked-date";
    },
    accessory_ordered_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-accessory-ordered-date");
      this.modal_id = "modal-edit-accessory-ordered-date";
    },
    accessory_received_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-accessory-received-date");
      this.modal_id = "modal-edit-accessory-received-date";
    },
    final_payment_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-final-payment-date");
      this.modal_id = "modal-edit-final-payment-date";
    },
    installation_booked_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-installation-booked-date");
      this.modal_id = "modal-edit-installation-booked-date";
    },
    job_complete_date_clicked(item) {
      this.viewed_follow_up_report = item;
      this.showModal("modal-edit-job-complete-date");
      this.modal_id = "modal-edit-job-complete-date";
    },
    inscription_dates_clicked(item) {
      this.viewed_follow_up_report = _.cloneDeep(item);
      this.showModal('modal-inscription-dates');
      this.modal_id = "modal-inscription-dates";
    },
    photo_clicked(item) {
      this.viewed_follow_up_report = _.cloneDeep(item);
      this.showModal('modal-photo');
      this.modal_id = 'modal-photo';
    },
    accessory_dates_clicked(item) {
      this.viewed_follow_up_report = _.cloneDeep(item);
      this.showModal('modal-accessory-dates');
      this.modal_id = "modal-accessory-dates";
    },
    update_photo_dates(new_dates) {
      this.viewed_follow_up_report.photo.dates = new_dates;
      
      var new_progress = 0;
      for (var i = 0; i < new_dates.length; i++) {
        if (new_dates[i].date != "") ++new_progress;
      }

      this.viewed_follow_up_report.photo.progress = new_progress;
    },
    update_inscription_dates(new_dates) {
      this.viewed_follow_up_report.inscription.inscription_dates = new_dates;

      var new_progress = 0;
      for (var i = 0; i < new_dates.length; i++) {
        if (new_dates[i].date != "") ++new_progress;
      }

      this.viewed_follow_up_report.inscription.inscription_progress = new_progress;
    },
    updateInscriptionFiles(files) {
      this.viewed_follow_up_report.inscription.inscription_files = files;
      this.edit_follow_up_report();
    },
    update_accessory_cross_dates(new_dates) {
      this.viewed_follow_up_report.accessory.cross.cross_dates = new_dates;
    
      var new_progress = 0;
      for (var i = 0; i < new_dates.length; i++) {
        if (new_dates[i].date != "") ++new_progress;
      }

      this.viewed_follow_up_report.accessory.cross.cross_progress = new_progress;
      const result = this.calculate_accessory_progress();
      this.viewed_follow_up_report.accessory.progress = result.progress;
      this.viewed_follow_up_report.accessory.required_item_number = result.required_item_number;
    },
    update_accessory_door_dates(new_dates) {
      this.viewed_follow_up_report.accessory.door.door_dates = new_dates;
    
      var new_progress = 0;
      for (var i = 0; i < new_dates.length; i++) {
        if (new_dates[i].date != "") ++new_progress;
      }

      this.viewed_follow_up_report.accessory.door.door_progress = new_progress;
      const result = this.calculate_accessory_progress();
      this.viewed_follow_up_report.accessory.progress = result.progress;
      this.viewed_follow_up_report.accessory.required_item_number = result.required_item_number;
    },
    update_accessory_decoration_dates(new_dates) {
      this.viewed_follow_up_report.accessory.decoration.decoration_dates = new_dates;
    
      var new_progress = 0;
      for (var i = 0; i < new_dates.length; i++) {
        if (new_dates[i].date != "") ++new_progress;
      }

      this.viewed_follow_up_report.accessory.decoration.decoration_progress = new_progress;
      const result = this.calculate_accessory_progress();
      this.viewed_follow_up_report.accessory.progress = result.progress;
      this.viewed_follow_up_report.accessory.required_item_number = result.required_item_number;
    },
    update_accessory_lantern_dates(new_dates) {
      this.viewed_follow_up_report.accessory.lantern.lantern_dates = new_dates;
    
      var new_progress = 0;
      for (var i = 0; i < new_dates.length; i++) {
        if (new_dates[i].date != "") ++new_progress;
      }

      this.viewed_follow_up_report.accessory.lantern.lantern_progress = new_progress;
      const result = this.calculate_accessory_progress();
      this.viewed_follow_up_report.accessory.progress = result.progress;
      this.viewed_follow_up_report.accessory.required_item_number = result.required_item_number;
    },
    update_accessory_photo_frame_dates(new_dates) {
      this.viewed_follow_up_report.accessory.photo_frame.photo_frame_dates = new_dates;
    
      var new_progress = 0;
      for (var i = 0; i < new_dates.length; i++) {
        if (new_dates[i].date != "") ++new_progress;
      }

      this.viewed_follow_up_report.accessory.photo_frame.photo_frame_progress = new_progress;
      const result = this.calculate_accessory_progress();
      this.viewed_follow_up_report.accessory.progress = result.progress;
      this.viewed_follow_up_report.accessory.required_item_number = result.required_item_number;
    },
    calculate_accessory_progress() {
      var required_item = 0;
      var new_progress = 0;
      if (!this.viewed_follow_up_report.accessory.cross.cross_not_required) {
        new_progress += this.viewed_follow_up_report.accessory.cross.cross_progress;
        required_item++;
      }
      if (!this.viewed_follow_up_report.accessory.door.door_not_required) {
        new_progress += this.viewed_follow_up_report.accessory.door.door_progress;
        required_item++;
      }
      if (!this.viewed_follow_up_report.accessory.decoration.decoration_not_required) {
        new_progress += this.viewed_follow_up_report.accessory.decoration.decoration_progress;
        required_item++;
      }
      if (!this.viewed_follow_up_report.accessory.lantern.lantern_not_required) {
        new_progress += this.viewed_follow_up_report.accessory.lantern.lantern_progress;
        required_item++;
      }
      if (!this.viewed_follow_up_report.accessory.photo_frame.photo_frame_not_required) {
        new_progress += this.viewed_follow_up_report.accessory.photo_frame.photo_frame_progress;
        required_item++;
      }
      return {progress: new_progress, required_item_number: required_item};
    },
    update_accessory_cross_not_required(new_data) {
      this.viewed_follow_up_report.accessory.cross.cross_not_required = new_data;
      if (new_data) this.viewed_follow_up_report.accessory.required_item_number -= 1;
      else this.viewed_follow_up_report.accessory.required_item_number += 1;

      if (this.viewed_follow_up_report.accessory.required_item_number == 0) {
        this.viewed_follow_up_report.accessory.not_required = true;
      } else {
        this.viewed_follow_up_report.accessory.not_required = false;
      }

      this.viewed_follow_up_report.accessory.progress = this.calculate_accessory_progress().progress;
    },
    update_accessory_door_not_required(new_data) {
      this.viewed_follow_up_report.accessory.door.door_not_required = new_data;
      if (new_data) this.viewed_follow_up_report.accessory.required_item_number -= 1;
      else this.viewed_follow_up_report.accessory.required_item_number += 1;

      if (this.viewed_follow_up_report.accessory.required_item_number == 0) {
        this.viewed_follow_up_report.accessory.not_required = true;
      } else {
        this.viewed_follow_up_report.accessory.not_required = false;
      }

      this.viewed_follow_up_report.accessory.progress = this.calculate_accessory_progress().progress;
    },
    update_accessory_decoration_not_required(new_data) {
      this.viewed_follow_up_report.accessory.decoration.decoration_not_required = new_data;
      if (new_data) this.viewed_follow_up_report.accessory.required_item_number -= 1;
      else this.viewed_follow_up_report.accessory.required_item_number += 1;

      if (this.viewed_follow_up_report.accessory.required_item_number == 0) {
        this.viewed_follow_up_report.accessory.not_required = true;
      } else {
        this.viewed_follow_up_report.accessory.not_required = false;
      }

      this.viewed_follow_up_report.accessory.progress = this.calculate_accessory_progress().progress;
    },
    update_accessory_lantern_not_required(new_data) {
      this.viewed_follow_up_report.accessory.lantern.lantern_not_required = new_data;
      if (new_data) this.viewed_follow_up_report.accessory.required_item_number -= 1;
      else this.viewed_follow_up_report.accessory.required_item_number += 1;

      if (this.viewed_follow_up_report.accessory.required_item_number == 0) {
        this.viewed_follow_up_report.accessory.not_required = true;
      } else {
        this.viewed_follow_up_report.accessory.not_required = false;
      }

      this.viewed_follow_up_report.accessory.progress = this.calculate_accessory_progress().progress;
    },
    update_accessory_photo_frame_not_required(new_data) {
      this.viewed_follow_up_report.accessory.photo_frame.photo_frame_not_required = new_data;
      if (new_data) this.viewed_follow_up_report.accessory.required_item_number -= 1;
      else this.viewed_follow_up_report.accessory.required_item_number += 1;

      if (this.viewed_follow_up_report.accessory.required_item_number == 0) {
        this.viewed_follow_up_report.accessory.not_required = true;
      } else {
        this.viewed_follow_up_report.accessory.not_required = false;
      }
      
      this.viewed_follow_up_report.accessory.progress = this.calculate_accessory_progress().progress;
    },
    testFunction() {
      console.log("TEST FUNCTION");
      const db = firebase.firestore();

      db.collection("follow_up_reports").get()
        .then((collection) => {
          var rows = collection.docs.map(doc => doc.data());
          rows.forEach((data) => {
            // if (data.inscription == null) {
            //   console.log(data);
            //   var new_progress = 0;
            //   if (data.inscription_got_date.length > 0) new_progress++;
            //   if (data.inscription_sent_date.length > 0) new_progress++;
            //   if (data.inscription_signed_date.length > 0) new_progress++;
            //   if (data.inscription_booked_date.length > 0) new_progress++;
            //   data.inscription = {
            //     inscription_progress: new_progress,
            //     inscription_not_required: data.inscription_got_date_not_required != null ? data.inscription_got_date_not_required : false,
            //     inscription_comment: data.inscription_got_date_comment != null ? data.inscription_got_date_comment : "",
            //     inscription_files: [],
            //     inscription_dates: [
            //       {name: "Writing Recd", date: data.inscription_got_date},
            //       {name: "Sent", date: data.inscription_sent_date},
            //       {name: "Signed", date: data.inscription_signed_date},
            //       {name: "Booked", date: data.inscription_booked_date},
            //     ],
            //   };
            // }

            // data.inscription.inscription_required_item_number = 4;
            
            // if (data.accessory == null) {
            //   data.accessory = {
            //     progress: 0,
            //     required_item_number: 4,
            //     not_required: false,
            //     comment: "",
            //     cross: {
            //       name: "Cross",
            //       cross_not_required: false,
            //       cross_progress: 0,
            //       cross_required_item_number: 2,
            //       cross_dates: [
            //         {name: "Ordered", date: ""},
            //         {name: "Received", date: ""},
            //       ]
            //     },
            //     door: {
            //       name: "Door",
            //       door_not_required: false,
            //       door_progress: 0,
            //       door_required_item_number: 2,
            //       door_dates: [
            //         {name: "Ordered", date: ""},
            //         {name: "Received", date: ""},
            //       ],
            //     },
            //     lantern: {
            //       name: "Lantern",
            //       lantern_not_required: false,
            //       lantern_progress: 0,
            //       lantern_required_item_number: 2,
            //       lantern_dates: [
            //         {name: "Ordered", date: ""},
            //         {name: "Received", date: ""},
            //       ],
            //     },
            //     decoration: {
            //       name: "Decoration",
            //       decoration_not_required: false,
            //       decoration_progress: 0,
            //       decoration_required_item_number: 2,
            //       decoration_dates: [
            //         {name: "Ordered", date: ""},
            //         {name: "Received", date: ""},
            //       ],
            //     },
            //   };
            // }

            // data.accessory.not_required = data.accessory_ordered_date_not_required != null ? data.accessory_ordered_date_not_required : false;

            // data.order_received_date = "";
            // data.stone_order_not_required = false;
            // data.order_received_date_comment = "";

            // data.photo = {
            //   dates: [
            //     {name: "Ordered", date: data.photo_sent_date},
            //     {name: "Received", date: data.photo_approved_date},
            //   ],
            //   shape: "",
            //   size: "",
            //   quantity: "",
            //   colour: "",
            //   not_required: false,
            //   required_item_number: 2,
            //   progress: 0,
            //   files: [],
            //   comment: ""
            // };

            // if (data.photo.dates[0].date != "") data.photo.progress += 1;
            // if (data.photo.dates[1].date != "") data.photo.progress += 1;
            // if (data.permit_sent_date_not_required
            //   || data.order_placed_date_not_required
            //   || data.foundation_ordered_date_not_required) {
            //   console.log(data.invoice_number + ' permit:' + data.permit_sent_date_not_required
            //     +' stone:' + data.order_placed_date_not_required
            //     +' foundation:' + data.foundation_ordered_date_not_required);
            // }

            // if (data.foundation_done_date == null) {
            //   data.foundation_done_date = "";

            //   const follow_up_report_ref = firebase.firestore().collection("follow_up_reports").doc(data.id);
            //   follow_up_report_ref.set(data, {merge: true}).then(() => {
            //     console.log('Test function finished.');
            //   });
            // }

            // data.accessory.photo_frame = {
            //   name: "Photo Frame",
            //   photo_frame_not_required: false,
            //   photo_frame_progress: 0,
            //   photo_frame_required_item_number: 2,
            //   photo_frame_dates: [
            //     {name: "Ordered", date: ""},
            //     {name: "Received", date: ""},
            //   ],
            // }

            // if (data.photo != null && data.photo.required_item_number != 2) {
            //   console.log(data.photo.required_item_number);

            //   data.photo.required_item_number = 2;

            //   const follow_up_report_ref = firebase.firestore().collection("follow_up_reports").doc(data.id);
            //   follow_up_report_ref.set(data, {merge: true}).then(() => {
            //     console.log('Test function finished.');
            //   });
            // }

            data.final_payment_date = "";
            const follow_up_report_ref = firebase.firestore().collection("follow_up_reports").doc(data.id);
            follow_up_report_ref.set(data, {merge: true}).then(() => {
              console.log('Test function finished.');
            });

            // firebase
            //   .firestore()
            //   .collection("follow_up_reports")
            //   .doc(data.id)
            //   .delete()
          });
        });
    },
  },
};
</script>

<style scoped>
.flexbox {
  display: flex;
}

.table-button {
  min-width: 80px;
  min-height: 24px;
  padding: 0;
  /* font-size: 14px; */
}

.table-button:hover {
  color: blue;
  background-color: Gainsboro;
  text-decoration: underline;
}
</style>
